<template>
  <div
    style="background-color: #fff"
    v-loading.fullscreen.lock="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <el-container class="intelligent-page">
      <!-- 侧边栏拖拽部分 -->
      <el-aside
        class="padding-20"
        style="transition: width 0.3s"
        :class="asideStatus ? 'aside_main_show' : 'right-box-shodow'"
      >
        <el-collapse v-model="activeName">
          <el-collapse-item
            v-for="(item, index) in icons"
            :key="index"
            :title="item.title"
            :name="index + 1"
          >
            <ul>
              <li
                v-for="(sitem, sindex) in item.chliden"
                draggable="true"
                @dragstart="dragstart($event, sitem)"
                :key="sindex"
                @mouseenter="checkouts(sitem)"
                @mouseleave="checkouts1"
                @mousedown="checkouts1"
              >
                <!-- 鼠标左侧移入显示文案 -->
                <div v-show="names == sitem.name" class="popUp">
                  <span
                    @mouseenter="checkouts1"
                    class="popUp1 arrow"
                    v-if="names == '合并'"
                    >可把多个人群合并为一个人群</span
                  >
                  <span
                    @mouseenter="checkouts1"
                    class="popUp1 arrow"
                    v-if="names == '交集'"
                    >可筛选出同时符合多个人群的共同人群</span
                  >
                  <span
                    @mouseenter="checkouts1"
                    class="popUp1 arrow"
                    v-if="names == '抽取'"
                    >可从一个人群按比例或指定人数抽取为多个人群</span
                  >
                  <span
                    @mouseenter="checkouts1"
                    class="popUp1 arrow"
                    v-if="names == '排除'"
                    >指定人群排除特定人群，即在A人群中排除B人群</span
                  >
                  <span
                    @mouseenter="checkouts1"
                    class="popUp1 arrow"
                    v-if="names == '排重'"
                    >把多个人群中的重复人群进行去重处理</span
                  >
                </div>
                <i :class="'icon-' + sitem.icon"></i>
                <span class="collapse-name">{{ sitem.name }}</span>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
      <!-- 主体部分gojs -->
      <el-main
        class="padding-0"
        style="
          padding: 12px 20px 0px 20px;
          position: relative;
          width: 100%;
          overflow: hidden;
        "
      >
        <!-- 收缩按钮 -->
        <div class="contractIcon" @click="asidechange">
          <i class="el-icon-arrow-left" v-if="aside_open_close"></i>
          <i class="el-icon-arrow-right" v-else></i>
        </div>
        <div class="tools">
          <tool-header
            :statusNum="statusNum"
            :activityData="tableData"
            @iconHome="iconHome"
            @activityCommand="changeValue2"
            @dialogVisiTemp="dialogVisiTemp"
            @saveAstemplateClick="saveAstemplateClick"
            @importCanvas="importCanvas"
            @effectReport="rulesOpitonChange"
            @usingTutorials="usingTutorials"
          >
            <div slot="activityName" class="name new-input-box">
              <span v-if="modify" @click="editA" class="name-text">{{
                actName
              }}</span>
              <el-input
                ref="nameRef"
                class="name-input"
                v-if="modifyOne"
                @blur="changeBlur"
                v-model="inputEdit"
                placeholder="请输入内容"
              >
              </el-input>
            </div>
          </tool-header>
          <div class="tools-tip">
            <span>注：所有操作都会实时保存</span>
          </div>
        </div>
        <ToolBar
          :statusNum="statusNum"
          :sendOptions="option1"
          :openSend="checkedNum == 1"
          :gridVisible="gridVisible"
          @testMSG="testMSG"
          @sendCommand="changeValue1"
          @reset="reset"
          @copy="copy"
          @deleteOne="deleteOne"
          @revokeBtn="revokeBtn"
          @redoBtn="redoBtn"
          @backout="backout"
          @recover="recover"
          @layout="usingTutorials1"
          @hideGrid="hideGrid"
          @replacement="replacement"
          @oneClickNaming="oneClickNaming"
          @setingMore="setingMore"
          @openQuick="openQuick"
          @includeMode ='includeMode'
          @intersectionMode = 'intersectionMode'
          @dragMode = 'dragMode'
        />
<!-- 
        <div
          style="
            width: 94%;
            line-height: 25px;
            color: red;
            margin-left: 17px;
            margin-top: 4px;
            margin-bottom: 10px;
            font-size: 12px;
          "
        >
          <div>
            注意：（1）双11大促期间短信发送时间：10月9日、10月10日、10月14日-10月16日、10月30日-11月1日、11月9日-11月11日 9:00-24:00 ；10月11日-10月13日、10月17日-10月29日、11月2日—11月8日 9:00-21:00 ；11月12日起恢复正常，即 09:00-20:00（*包含普通短信、富信、卡片短信）
          </div>
          <div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）10月9日-11月11日双11大促期频控规则：同一店铺2天内给同一手机号发送商家营销短信的条数不超过1条;每个手机号每1天只能收到5条商家营销短信,每2天只能收到10条商家营销短信（*商家营销短信包括普通短信、富信、卡片短信）
          </div>
        </div> -->
        <!-- gojs -->
        <div class="canvas-box" ref="canvas" @drop="drop" @dragover.prevent>
          <diagram
            ref="diag"
            :isOverview="isOverview"
            :edit="edit"
            :model-data="diagramData"
            :is-read-only.sync="isReadOnly"
            :icons="icons"
            :showFull="showFull"
            @open-msg="openMsg"
            @model-changed="modelChanged"
            @changed-selection="changedSelection"
            @object-double-clicked="objectDoubleClicked"
            @object-delete="objectDelete"
            @LinkDrawn="LinkDrawn"
            @select-tion-moved="nodeView"
            @select-tion-SelectionCopied="SelectionCopied"
            @revoke="revoke"
            @redo="redo"
            @saveAs="saveAstemplateClick"
            @object-delete1="deleteOne"
            @copy-change="copy"
            @afterNodeClick="afterNodeClick"
            @mouseEventChange="mouseEvents"
            @toggleFull="diagramToggleFull"
          >
          </diagram>
          <!-- 合并 -->
          <merge-dialog
            v-if="mergeVisible"
            :visible.sync="mergeVisible"
            :is-read-only.sync="isReadOnly"
            :node-id="nodeId"
            :marketing-id="id"
            @change-name="changedName"
          >
          </merge-dialog>
          <!-- 排除 -->
          <exclude-dialog
            v-if="excludeVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="excludeVisible"
            @change-name="changedName"
          >
          </exclude-dialog>
          <!-- 交集 -->
          <intersection-dialog
            v-if="intersectionVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="intersectionVisible"
            @change-name="changedName"
          >
          </intersection-dialog>
          <!-- 抽取 -->
          <extraction-dialog
            v-if="extractionVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="extractionVisible"
            @change-name="changedName"
            @change="extractionChange"
          >
          </extraction-dialog>
          <!-- 排重 -->
          <unique-dialog
            v-if="uniqueVisible"
            :node-id="nodeId"
            :marketing-id="id"
            :is-read-only.sync="isReadOnly"
            :visible.sync="uniqueVisible"
            @change="extractionChanges"
            @change-name="changedName"
          ></unique-dialog>
          <!-- 预览 -->
          <sms-info
            v-if="smsPreviewShow"
            @close="smsPreviewShow = false"
            :cusuffix="smsPreview.cusuffix"
            :content="smsPreview.content"
            :isShow="smsPreviewShow"
          >
          </sms-info>
          <!-- 另存为模板弹框 -->
          <el-dialog
            title="另存为模板"
            width="500px"
            :visible.sync="dialogTemplateFormVisible"
            :close-on-click-modal="false"
          >
            <el-form :model="formTemplate" :rules="rulest" ref="formTemplate">
              <el-form-item label="模板名称" prop="name" :label-width="'90px'">
                <el-input
                  v-model="formTemplate.name"
                  autocomplete="off"
                  maxlength="20"
                >
                  <span
                    slot="suffix"
                    style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    "
                    >{{ formTemplate.name.length }}/20</span
                  >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogTemplateFormVisible = false"
                >取 消</el-button
              >
              <el-button type="primary" @click="saveAsTemplate" v-preventReClick
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </div>
        <!-- Note测试执行 -->
        <div
          :class="{ testClass: 1, testClassShow: !openCollapse }"
          v-if="statusNum == 4"
        >
          <div
            class="class"
            v-if="!openCollapse"
            @click="collapse"
            style="color: #999999; cursor: pointer"
          >
            <i class="el-icon-caret-left"></i>
          </div>
          <div
            class="class"
            v-if="openCollapse"
            @click="collapse"
            style="color: #999999; cursor: pointer"
          >
            <i class="el-icon-caret-right"></i>
          </div>
          <div v-if="openCollapse" style="height: 20px">执行结果</div>
          <div>
            <div style="color: #333; font-size: 14px">测试执行结果</div>
            <div>
              <span
                >人群数量汇总预估：<span style="color: #2062e7">{{
                  allCount ? allCount : 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="smCount > 0">
              <span
                >总触达人数预估：<span style="color: #2062e7">{{
                  smCount ? smCount.toLocaleString() : 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <!-- 普通短信 -->
            <div v-if="hasSms&&smCount > 0">
              <span style="font-weight: bold">普通短信：</span>
              <span
                >触达人数预估：<span style="color: #2062e7">{{
                  testSmsQuery.touchCount.toLocaleString() || 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >消耗短信预估：<span style="color: #2062e7">{{
                  testSmsQuery.msgCount.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="color: #ff5454" v-if="testSmsQuery.warning"
                >普通短信余额不足，当前余额{{
                  testSmsQuery.warning.toLocaleString()
                }}条，余额不足会导致部分批次无法提交</span
              >
            </div>
            <div v-if="hasMedialSms&&smCount > 0">
              <span style="font-weight: bold"
                >富信:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
              <span
                >触达人数预估：<span style="color: #2062e7">{{
                  testSmsQuery.mediaTouchCount.toLocaleString() || 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >消耗富信预估：<span style="color: #2062e7">{{
                  testSmsQuery.mediaMsgCount.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="color: #ff5454" v-if="testSmsQuery.mediaWarning"
                >富信余额不足，当前余额{{
                  testSmsQuery.mediaWarning.toLocaleString()
                }}条，余额不足会导致部分批次无法提交</span
              >
            </div>
            <div v-if="hasCardSms&&smCount > 0">
              <span style="font-weight: bold">卡片短信：</span>
              <span
                >触达人数预估：<span style="color: #2062e7">{{
                  testSmsQuery.cardTouchCount.toLocaleString() || 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >消耗卡片预估：<span style="color: #2062e7">{{
                  testSmsQuery.cardMsgCount.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                style="color: #ff5454"
                v-if="
                  testSmsQuery.cardWarning || testSmsQuery.cardWarning === 0
                "
                >卡片短信余额不足，当前余额{{
                  testSmsQuery.cardWarning.toLocaleString()
                }}条，余额不足会导致部分批次无法提交</span
              >
            </div>
            <!-- <div style="color: #ff5454" v-if="smCountOne">
              您短信余额不足，当前余额：{{ smCountOne }}
              条，余额不足会导致部分批次无法提交
            </div> -->
            <!-- <div style="color: red">
              温馨提示：日常发送时间范围：早9:00-晚20:00
            </div>
            <div style="color: red">
              临近结束时间执行任务，会导致短信超时发送失败，建议正式执行时间点最晚不超过19:30（请勿定时19:55分执行）
            </div> -->
          </div>
        </div>
        <!-- 正式执行 -->
        <div
          :class="{ testClass: 1, testClassShow: !openCollapse }"
          v-if="feld"
        >
          <div
            class="class"
            v-if="!openCollapse"
            @click="collapse"
            style="color: #999999; cursor: pointer"
          >
            <i class="el-icon-caret-left"></i>
          </div>
          <div
            class="class"
            v-if="openCollapse"
            @click="collapse"
            style="color: #999999; cursor: pointer"
          >
            <i class="el-icon-caret-right"></i>
          </div>
          <div v-if="openCollapse" style="height: 20px">执行结果</div>
          <!-- v-if="!openCollapse" -->
          <div>
            <div style="color: #333; font-size: 14px">正式执行结果</div>
            <div>
              <span
                >执行时间：<span>{{ querycheck.time }}</span></span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >总触达人数：<span style="color: #2062e7">{{
                  querycheck.totalNumber.toLocaleString()
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="hasSms">
              <span style="font-weight: bold">普通短信：</span>
              <span
                >触达人数：<span style="color: #2062e7">{{
                  querycheck.touchCount.toLocaleString() || 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >消耗短信：<span style="color: #2062e7">{{
                  querycheck.msgCount.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >已发送：<span style="color: #2062e7">{{
                  querycheck.sendIngNum.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >待发送：<span style="color: #2062e7">{{
                  querycheck.waitNum.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="hasMedialSms">
              <span style="font-weight: bold"
                >富信:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
              <span
                >触达人数：<span style="color: #2062e7">{{
                  querycheck.mediaTouchCount.toLocaleString() || 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >消耗富信：<span style="color: #2062e7">{{
                  querycheck.mediaMsgCount.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >已发送：<span style="color: #2062e7">{{
                  querycheck.mediaSendIngNum.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >待发送：<span style="color: #2062e7">{{
                  querycheck.mediaWaitNum.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div v-if="hasCardSms">
              <span style="font-weight: bold">卡片短信：</span>
              <span
                >触达人数：<span style="color: #2062e7">{{
                  querycheck.cardTouchCount.toLocaleString() || 0
                }}</span>
                人</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >消耗卡片：<span style="color: #2062e7">{{
                  querycheck.cardMsgCount.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >已发送：<span style="color: #2062e7">{{
                  querycheck.cardSendIngNum.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >待发送：<span style="color: #2062e7">{{
                  querycheck.cardWaitNum.toLocaleString() || 0
                }}</span>
                条</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          </div>
        </div>

        <!-- 底部 -->
        <div
          v-if="foreError == 1"
          style="float: right; color: #e6a23c; margin-bottom: 10px"
        >
          温馨提示：出现节点设置异常，鼠标移入 "<img
            :src="imagePicture"
            style="width: 12px; height: 12px; vertical-align: middle"
          />" 可查看错误信息！
        </div>
      </el-main>
    </el-container>

    <!-- 会员分群 -->
    <membership-dialog
      v-if="vipVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :is-read-only.sync="isReadOnly"
      :visible.sync="vipVisible"
      @change-name="changedName"
      @changeInit="changeInit"
      :namingRules="useQuickForm.namingRules"
      :isSplitCrowdConfig="isSplitCrowd"
    >
    </membership-dialog>
    <!-- 短信 -->
    <sms-send-dialog
      v-if="msgVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :is-read-only.sync="isReadOnly"
      :visible.sync="msgVisible"
      :msgMore="msgMore"
      :nodeNumListBatchNumOne="nodeNumListBatchNumOne"
      @change-name="changedName"
    ></sms-send-dialog>
    <!-- Note富信节点 -->
    <medium-dialog
      v-if="mediumVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :is-read-only.sync="isReadOnly"
      :visible.sync="mediumVisible"
      @change-name="changedName"
    ></medium-dialog>
    <!-- Note卡片短信节点 -->
    <card-dialog
      v-if="cardVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :is-read-only.sync="isReadOnly"
      :visible.sync="cardVisible"
      @change-name="changedName"
    ></card-dialog>
    <!-- Note结束 -->
    <!-- 短信分析 -->
    <sms-analysis
      v-if="analyzeVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :visible.sync="analyzeVisible"
      :is-read-only.sync="isReadOnly"
      @change-name="changedName"
    ></sms-analysis>
    <!-- 等待节点 -->
    <await-dialog
      v-if="awaitVisible"
      :visible.sync="awaitVisible"
      :is-read-only.sync="isReadOnly"
      @change-name="changedName"
      :marketing-id="id"
      :node-id="nodeId"
    ></await-dialog>
    <exec-dialog
      v-if="execVisible"
      :visible.sync="execVisible"
      :marketing-id="id"
      @change="excChange"
    ></exec-dialog>

    <customer-dialog
      v-if="customerVisible"
      :node-id="nodeId"
      :marketing-id="id"
      :marketStatus="marketStatus"
      :visible.sync="customerVisible"
      @change="excChange"
    >
    </customer-dialog>
    <order-dialog
      v-if="orderVisible"
      :node-id="nodeId"
      :is-read-only.sync="isReadOnly"
      :visible.sync="orderVisible"
      :marketing-id="id"
      @change-name="changedName"
    ></order-dialog>
    <presell-dialog
      v-if="presellVisible"
      :node-id="nodeId"
      :is-read-only.sync="isReadOnly"
      :visible.sync="presellVisible"
      :marketing-id="id"
      @change-name="changedName"
    ></presell-dialog>

    <el-dialog
      title="测试执行结果"
      :visible.sync="batchVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="batchVisible = false"
    >
      <div class="batchdiv">
        本次活动共 <span style="color: #3737cb">{{ batchItem.batchNum }}</span
        >个批次
      </div>
      <div class="batchdiv">
        预计发送人数：<span style="color: #3737cb">{{
          batchItem.sumCount
        }}</span
        >人（仅以当前时间计算人数）
      </div>
      <div class="batchdiv">
        预计消耗短信条数：<span style="color: #3737cb">{{
          batchItem.msgCount
        }}</span
        >条（仅以当前时间计算人数）
      </div>
      <div v-if="batchItem.warning" class="batchdiv bgimg">
        您短信余额不足，当前余额：{{
          batchItem.warning
        }}条，余额不足会导致部分批次无法提交
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--Note立即执行 -->
    <el-dialog
      title="立即执行"
      :visible.sync="execute"
      :close-on-click-modal="false"
      width="715px"
      @close="close"
    >
      <div style="margin-left: 1px; margin-bottom: 30px">
        是否确认立即执行。
      </div>
      <span class="require-icon">异常提醒</span> &nbsp;&nbsp;&nbsp;
      <el-input
        v-model.number="remindMobile"
        style="width: 220px"
        autocomplete="off"
        maxlength="11"
        placeholder="请输入手机号"
        @keyup="limitInput($event)"
      ></el-input
      >&nbsp;
      <el-tooltip
        class="item"
        effect="light"
        content="当出现短信提交异常情况时，会进行短信提醒"
        placement="right"
      >
        <i class="el-icon-question" style="color: #2062e7; font-size: 14px"></i>
      </el-tooltip>
      <div
        style="
          margin-left: 70px;
          margin-bottom: 30px;
          margin-top: 20px;
          color: red;
        "
      >
        注意：
        <p style="line-height: 20px">
          <!-- 1.所有富信均需京东侧及运营商处人工审核（周末不审核），审核周期较长，避免短信发送失败，需设定执行时间比实际发送时间提前2-3工作日以上； -->
        </p>
        <p style="line-height: 20px">
          1.如无等待节点，需在实际发送时间前1个工作日以上执行。
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="execute = false">取 消</el-button>
        <el-button type="primary" @click="execSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- Note定时执行 -->
    <el-dialog
      title="定时执行"
      :visible.sync="executeTwo"
      :close-on-click-modal="false"
      width="715px"
      @close="close"
    >
      <div class="lineBox">
        <span>执行时间 </span>&nbsp;&nbsp;&nbsp;
        <el-date-picker
          v-model="execform.timingExecutionTime"
          :editable="false"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </div>
      <div style="margin-left: 70px; margin-bottom: 30px; margin-top: 20px">
        到执行时间点进行人群的计算，执行时间建议提前实际发送时间20分钟以上，推荐设置等待节点。
      </div>
      <div>
        <span class="require-icon">异常提醒</span> &nbsp;&nbsp;&nbsp;
        <el-input
          v-model.number="remindMobile"
          style="width: 220px"
          autocomplete="off"
          maxlength="11"
          placeholder="请输入手机号"
          @keyup="limitInput($event)"
        ></el-input
        >&nbsp;
        <el-tooltip
          class="item"
          effect="light"
          content="当出现短信提交异常情况时，会进行短信提醒"
          placement="right"
        >
          <i
            class="el-icon-question"
            style="color: #2062e7; font-size: 14px"
          ></i>
        </el-tooltip>
        <div
          style="
            margin-left: 70px;
            margin-bottom: 30px;
            margin-top: 20px;
            color: red;
          "
        >
          注意：
          <p style="line-height: 20px">
            <!-- 1.所有富信均需京东侧及运营商处人工审核（周末不审核），审核周期较长，避免短信发送失败，需设定执行时间比实际发送时间提前2-3工作日以上； -->
          </p>
          <p style="line-height: 20px">
            1.如无等待节点，需在实际发送时间前1个工作日以上执行。
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="executeTwo = false">取 消</el-button>
          <el-button type="primary" @click="execSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!--Note周期执行 -->
    <el-dialog
      title="周期执行"
      :visible.sync="executeOne"
      :close-on-click-modal="false"
      width="715px"
      @close="close"
    >
      <el-form :model="execform" :label-width="formLabelWidth">
        <el-form-item label="执行周期">
          <div class="lineBox">
            <el-radio v-model="execform.cycleExecutionType" :label="0"
              >按天:</el-radio
            >
            <span style="margin-left: 10px">每</span>
            <el-input
              v-model.number="execform.cycleDay"
              style="width: 100px; margin: 0 10px"
              autocomplete="off"
            ></el-input>
            <span>天</span>
          </div>
          <div class="lineBox">
            <el-radio v-model="execform.cycleExecutionType" :label="1"
              >按周:</el-radio
            >
            <span
              style="margin-left: 10px; display: inline-block; min-width: 32px"
              >每周</span
            >
            <el-checkbox-group
              v-model="execform.cycleDayWeekly"
              style="margin-left: 10px; line-height: 8px"
            >
              <el-checkbox
                v-for="(item, index) in cycleDayWeeklys"
                :key="index"
                :label="item.value"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="lineBox">
            <el-radio v-model="execform.cycleExecutionType" :label="2"
              >按月:</el-radio
            >
            <span
              style="margin-left: 10px; display: inline-block; min-width: 32px"
              >每月</span
            >
            <el-checkbox-group
              v-model="execform.cycleDayMonthly"
              style="margin-left: 10px; text-align: left; line-height: 20px"
            >
              <el-checkbox
                v-for="(item, index) in cycleDayMonthlys"
                :key="index"
                :label="item"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="执行时间">
          <div class="lineBox">
            <el-time-picker
              v-model="execform.cycleExecutionTime"
              :editable="false"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              prefix-icon="none"
              placeholder="具体时间点"
            >
            </el-time-picker>
          </div>
        </el-form-item>
        <el-form-item label="执行范围">
          <div class="lineBox">
            <el-date-picker
              v-model="execform.datetime"
              :editable="false"
              type="datetimerange"
              align="right"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions2"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
          <div style="margin-bottom: 30px; margin-top: 20px">
            到执行时间点进行人群的计算，执行时间建议提前实际发送时间20分钟以上（如节点包含富信，执行时间需提前实际发送时间1个工作日以上），推荐设置等待节点。
          </div>
          <span class="require-icon" style="margin-left: -68px">异常提醒</span>
          &nbsp;&nbsp;&nbsp;
          <el-input
            v-model.number="remindMobile"
            style="width: 220px"
            autocomplete="off"
            maxlength="11"
            placeholder="请输入手机号"
            @keyup="limitInput($event)"
          ></el-input
          >&nbsp;
          <el-tooltip
            class="item"
            effect="light"
            content="当出现短信提交异常情况时，会进行短信提醒"
            placement="right"
          >
            <i
              class="el-icon-question"
              style="color: #2062e7; font-size: 14px"
            ></i>
          </el-tooltip>
          <div
            style="
              margin-left: 0px;
              margin-bottom: 30px;
              margin-top: 20px;
              color: red;
            "
          >
            <!-- 注意：所有富信均需京东侧及运营商处人工审核（周末不审核），审核周期较长，避免短信发送失败，周期执行时间不建议按天，且需设定执行时间比正式发送时间提前2-3工作日以上； -->
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="executeOne = false">取 消</el-button>
        <el-button type="primary" @click="execSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 营销效果导出 -->
    <el-dialog title="统计时间" width="650px" :visible.sync="staVisible">
      <template slot="title">
        <span
          style="
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 6px;
          "
          >统计时间</span
        >
        <el-popover placement="right" width="400" trigger="hover">
          营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供
          <i
            class="el-icon-question"
            slot="reference"
            style="color: #aaaaaa"
          ></i>
        </el-popover>
      </template>
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select
            style="width: 100px"
            v-model="staValue"
            @change="staValueChange"
          >
            <el-option
              v-for="(item, index) in statiType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <template v-if="staValue == ''">
            <el-select style="margin: 0 10px; width: 110px" v-model="timeType">
              <el-option label="相对时间" :value="1"></el-option>
              <el-option label="绝对时间" :value="2"></el-option>
            </el-select>
            <el-input
              style="width: 160px"
              v-model="customValue"
              @keyup.native="customValue = limitInput1($event)"
              v-if="timeType == 1"
            >
              <template slot="suffix"> 天 </template>
            </el-input>
            <div class="my_select_time" v-else>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="startTime"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="endTime"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption"
                default-time="23:59:59"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearEffectTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </template>
        </el-form-item>
      </el-form>
      <div class="footer">
        <button class="cancel" @click="closeStaVisible">取消</button>
        <button class="confirm" @click="batchUpload">确定</button>
      </div>
    </el-dialog>

    <!-- 咚咚效果导出 -->
    <el-dialog title="统计时间" width="650px" :visible.sync="staVisibleOne">
      <template slot="title">
        <span
          style="
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 6px;
          "
          >统计时间</span
        >
        <!-- <el-popover placement="right" width="400" trigger="hover">
          营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供
          <i
            class="el-icon-question"
            slot="reference"
            style="color: #aaaaaa"
          ></i>
        </el-popover> -->
      </template>
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select
            style="width: 100px"
            v-model="staValueOne"
            @change="staValueChangeOne"
          >
            <el-option
              v-for="(item, index) in statiTypeOne"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <template v-if="staValueOne == ''">
            <el-select style="margin: 0 10px; width: 110px" v-model="timeType2">
              <el-option label="相对时间" :value="1"></el-option>
              <el-option label="绝对时间" :value="2"></el-option>
            </el-select>
            <el-input
              style="width: 160px"
              v-model="customValue3"
              @keyup.native="customValue3 = limitInput1($event)"
              v-if="timeType2 == 1"
            >
              <template slot="suffix"> 天 </template>
            </el-input>
            <div class="my_select_time" v-else>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="startTime2"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption2"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="endTime2"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption2"
                default-time="23:59:59"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearEffectTime2()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </template>
        </el-form-item>
      </el-form>
      <div class="footer">
        <button class="cancel" @click="closeStaVisible2">取消</button>
        <button class="confirm" @click="batchUpload2">确定</button>
      </div>
    </el-dialog>
    <!-- end  -->

    <!-- 模板弹窗 -->
    <TemplateDialog
      v-if="dialogTemplateVisible"
      :dialogTemplateVisible="dialogTemplateVisible"
      :activityName="actName"
      :smartMarketingId="id"
      :nodeDataArray="diagramData.nodeDataArray"
      @close="dialogTemplateVisible = false"
      @setinit="setinit"
    />
    <el-dialog title="提示" width="650px" :visible.sync="isAdvanced">
      <div>
        <span
          ><i class="el-icon-info" :style="{ color: globalBG }"></i
          >该功能仅支持在云舟试用，请联系您的专属客服进行升级哦~
        </span>
        <!-- <span
          style="cursor: pointer"
          :style="{ color: globalBG }"
          @click="toDingGou"
          >去订购>></span
        > -->
      </div>
      <div class="footer">
        <button
          class="confirm"
          @click="isAdvanced = false"
          style="margin: 10px auto 0"
        >
          确定
        </button>
      </div>
    </el-dialog>
    <batchsetting-dialog
      v-if="batchsettingVisible"
      :batNum="batchSure"
      :nodeBatch="nodeNumListBatchNum"
      @close="close"
    ></batchsetting-dialog>

    <!-- 生成报表 -->
    <generate
      :control="control1"
      v-if="control1"
      @transData="(val) => (control1 = val)"
      @transData1="getphone1"
    ></generate>

    <!-- 人群分析导出处理 -->
    <generate1
      :control="control2"
      v-if="control2"
      @transData="(val) => (control2 = val)"
      :flags="flags"
    ></generate1>

    <!-- 咚咚消息导出处理 -->
    <generate2
      :control="control3"
      v-if="control3"
      @transData="(val) => (control3 = val)"
      @transData1="getphone3"
    ></generate2>

    <!-- 一键替换文案 -->
    <el-dialog
      title="查找与替换"
      width="650px"
      :visible.sync="oneClickReplacement"
      custom-class="publishDialog"
    >
      <div>
        <span>查找内容：</span>
        <el-input
          v-model="language"
          style="width: 500px"
          placeholder="请输入"
        ></el-input>
      </div>
      <div style="margin-top: 20px; margin-bottom: 10px"></div>
      <div>
        <span>替换内容：</span>
        <el-input
          v-model="language1"
          style="width: 500px"
          placeholder="请输入"
        ></el-input>
      </div>
      <div style="margin-top: 20px; margin-bottom: 10px"></div>
      <!-- 智能营销1.0优化 -->
      <div>
        <span>查找及替换范围：</span>
        <el-radio :label="7" v-model="replaceCheck">短信</el-radio>
        <el-radio :label="16" v-model="replaceCheck" :disabled="true"
          >咚咚消息</el-radio
        >
        <el-tooltip
          class="item"
          effect="light"
          content="仅替换咚咚消息富文本内容"
          placement="right"
        >
          <span class="question_icon" style="margin-left: -24px">?</span>
        </el-tooltip>
      </div>
      <div class="footer">
        <el-button class="cancel" @click="oneClickReplacement = false">
          取消
        </el-button>
        <el-button class="confirm" @click="replaceChange">确定</el-button>
      </div>
    </el-dialog>
    <!-- 替换确定提示 -->
    <el-dialog
      title="替换提示"
      width="500px"
      :visible.sync="oneClickReplacement1"
    >
      <div>
        全部完成。已完成<span style="color: red">&nbsp;{{ number }}&nbsp;</span
        >处替换！
      </div>
      <div class="footer">
        <button class="confirm" @click="oneClickReplacement1 = false">
          确定
        </button>
      </div>
    </el-dialog>
    <!-- 导入画布 -->
    <el-dialog title="导入画布" width="650px" :visible.sync="exportChat">
      <div>
        <span>上传文件：</span>
        <div style="margin-top: 10px; margin-bottom: 5px"></div>
        <span>
          <!-- action="https://jsonplaceholder.typicode.com/posts/":on-progress="handleProgress"-->
          <el-upload
            class="upload-demo"
            ref="upload"
            drag
            :file-list="fileList"
            action="#"
            :before-upload="beforeUpload"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </span>
      </div>
      <div style="margin-top: 10px">
        导入成功10条，导入失败20条，导入失败序号：1,2,3
      </div>
      <div style="margin-top: 20px; margin-bottom: 10px"></div>
      <div class="downClass">
        <el-button class="confirm" @click="downTemplate">下载模板</el-button>
      </div>
      <div class="footer">
        <el-button class="cancel" @click="exportChat = false">取消</el-button>
        <el-button class="confirm" @click="exportChat = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- 人群分析节点 -->
    <el-dialog :visible.sync="customerVisible2" width="548px" title="人群分析">
      <div class="tip-box">
        <img
          src="@/assets/images/new_icon_waring_yellow.png"
          class="tip-box-icon"
        />
        <span style="margin-left: 24px; color: #333"
          >人群分析从执行后第二天开始统计，最多统计执行后30天的数据</span
        >
      </div>
      <el-form :model="analyzeNodeDTO">
        <el-form-item label="节点名称：" prop="name">
          <!-- maxlength="32"  show-word-limit -->
          <el-input
            v-model="analyzeNodeDTO.name"
            placeholder="人群分析"
            style="width: 80%"
            class="ex-input"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerVisible2 = false">取 消</el-button>
        <el-button type="primary" :disabled="isReadOnly" @click="saveCustomer"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 正式发送后，人群库存数量超出限制弹框 -->
    <el-dialog :visible.sync="customerBlock" width="500px" title="人群分析">
      <div style="color: red; line-height: 35px">
        <div>该【人群分析】中途已终止</div>
        <div>原因：在执行过程中，您的人群库已超出数量限制</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerBlock = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- end -->

    <!-- 效果报表弹框 -->
    <el-dialog
      title="人群分析报表下载"
      width="650px"
      :visible.sync="staVisible1"
    >
      <div style="color: red; margin-bottom: 20px; margin-top: -10px">
        人群分析从执行后第二天开始统计，最多统计执行后30天的数据
      </div>
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select
            v-model="staValue1"
            style="width: 100px"
            @change="staValueChange1"
          >
            <el-option
              v-for="(item, index) in statiType1"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <template v-if="staValue1 == ''">
            <el-select style="margin: 0 10px; width: 110px" v-model="timeType1">
              <el-option label="相对时间" :value="1"></el-option>
              <el-option label="绝对时间" :value="2"></el-option>
            </el-select>
            <el-input
              style="width: 186px"
              v-model="customValue1"
              v-if="timeType1 == 1"
              @keyup.native="customValue1 = limitInput2($event)"
            >
              <template slot="suffix"> 天 </template>
            </el-input>
            <div class="my_select_time" v-else>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="startTime1"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption1"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="endTime1"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption1"
                default-time="23:59:59"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearEffectTime1()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </template>
        </el-form-item>
        <el-form-item label="添加备注" style="margin-left: 18px">
          <el-input
            show-word-limit
            maxlength="20"
            type="textarea"
            :rows="3"
            style="width: 220px; margin-left: 10px"
            v-model="customValue2"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <button class="cancel" @click="closeStaVisible1">取消</button>
        <button class="confirm" @click="batchUpload1">确定</button>
      </div>
    </el-dialog>
    <!-- end -->

    <!-- 快捷操作 -->
    <el-dialog
      :visible.sync="quickDailog"
      width="900px"
      title="画布配置"
      @closed="sureQuickChance"
    >
      <div v-if="!isCanCanvasConfig" style="color: red; margin-bottom: 10px;">使用该功能需开通云舟专业版/数智版，请联系您的专属客服处理哦~</div>
      <el-form :model="quickForm" :disabled="!isCanCanvasConfig">
        <el-form-item label="节点配置：">
          <el-radio-group v-model="quickForm.nodeConfig">
            <el-radio :label="0">自动弹出节点设置弹窗</el-radio>
            <el-radio :label="1">不弹出节点设置弹窗</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="人群节点拆分配置：">
          <el-checkbox v-model="isSplitCrowd"
            >人群节点默认勾选“拆分每个人群为一个节点”</el-checkbox
          >
        </el-form-item>
        <el-form-item label="人群节点命名规则：">
          <el-radio-group style="width: 640px" v-model="quickForm.namingRules">
            <el-radio style="margin-bottom: 8px" :label="0"
              >勾选单个人群时节点名称为人群名称，勾选多个人群且不拆分节点时不自动命名</el-radio
            >
            <el-radio :label="1"
              >勾选单个人群时节点名称为人群名称，勾选多个人群且不拆分节点时节点名称为最后勾选的人群名称</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="节点复制规则：">
          <el-radio-group v-model="quickForm.copyRules">
            <el-radio :label="0">复制内容</el-radio>
            <el-radio :label="1">仅复制节点，不复制内容</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="测试执行配置：">
          <el-checkbox v-model="checked" @change="checkedChange"
            >已测试执行的画布恢复设计后不需要测试执行，可直接操作正式执行</el-checkbox
          >
          <el-tooltip
            class="item"
            effect="light"
            content="若不进行测试执行，则无法预估发送人数和资源扣减情况，建议测试执行哦~"
            placement="top-start"
          >
            <span class="el-icon-question"></span>
          </el-tooltip>
          <div class="config-num">
            <el-checkbox v-model="isShowNum"
              >恢复设计后，节点仍然显示人数或消息条数</el-checkbox
            >
          </div>
        </el-form-item>
        <!-- 京东1.16 -->
        <el-form-item label="排重/抽取后节点配置：">
          <div>
            <span class="config-text">按顺序自动连接</span>
            <el-checkbox
              v-model="isAutoAddWaitNode"
              @change="checkedChangeWaits"
              >等待节点</el-checkbox
            >
            <el-checkbox v-model="isAutoAddTouchNode">
              <div>
                <span>触达节点</span>
                <el-select v-model="touchNode" class="config-select">
                  <el-option
                    v-for="item in touchNodeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-checkbox>
            <el-checkbox v-model="isAutoAddAnalysisNode">
              <span>短信分析</span>
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="正式执行异常提醒手机号：">
          <el-input
            style="width: 320px; margin-right: 8px"
            placeholder="请输入1个手机号"
            v-model="errorRemindMobile"
          ></el-input>
          <el-tooltip
            class="item"
            effect="light"
            content="该手机号在正式执行确认弹窗会作为默认手机号在异常提醒输入框展示"
            placement="top-start"
          >
            <span class="el-icon-question"></span>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quickDailog = false">取 消</el-button>
        <el-button type="primary" @click="sureQuick">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量设置节点 -->
    <nodeSetting
      ref="nodeSettingRef"
      v-if="showNodeSetting"
      :marketingId="id"
      v-model="showNodeSetting"
      @edit="showNodeDialog"
    />
  </div>
</template>
<script>
import { uploadMobile } from "@/api/uploadFile.js"; //上传文件
import { getMinWaitTime } from "@/api/intelligentMarket/index";
import {
  getIntelligentList,
  updateIntelligent,
  getRecordList,
  replaceContents,
  startActivity,
  getSetting,
  checkMarketingExecuted,
  exportCanvas,
  autoSetBatchNodeNames,
} from "@/api/intelligentMarket/index";
import { exportMarketing } from "@/api/smsMarketing";
import { uploadpic } from "@/api/marketing/dongdong";
import FullScreen from "@/components/fullScreen";
import screenfull from "screenfull";
import diagram from "./diagram";
import membershipDialog from "./membershipDialog";
import smsSendDialog from "./smsSendDialog";
import mediumDialog from "./mediumDialog";
import cardDialog from "./cardDialog";
import smsAnalysis from "./smsAnalysis";
import awaitDialog from "./awaitDialog";
import customerDialog from "./customerDialog";
import execDialog from "./execDialog";
import orderDialog from "./orderDialog";
import presellDialog from "./presellDialog";
import { getSellerInfo } from "@/api/sellerController"; //获取当前客户信息
import { mapState } from "vuex";
import mergeDialog from "./mergeDialog"; //合并
import excludeDialog from "./excludeDialog"; //排除
import intersectionDialog from "./intersectionDialog"; //交集
import extractionDialog from "./extractionDialog"; //抽取
import uniqueDialog from "./uniqueDialog"; //排重
import smsInfo from "./sms-info"; //预览
import mnode from "@/api/intelligentMarket/a_node";
import TemplateDialog from "@/components/template-dialog.vue";
import batchsettingDialog from "./batchsettingDialog"; //批量设置
import generate from "../../components/generate_report.vue";
import generate1 from "../../components/generate_report.vue";
import generate2 from "../../components/generate_report.vue"; //咚咚消息导出
import nodeSetting from "./nodeSetting.vue";
import ToolHeader from "./components/toolHeader.vue";
import ToolBar from "./components/toolBar.vue";
var activityInterval = null;

// // 区分360浏览器和其他浏览器
// if (typeof navigator.userAgentData == 'undefined'){
//   require("./less/icons-ms.less")
//   // 判断火狐浏览器
//   if(navigator.userAgent.indexOf("Firefox") != -1) {
//     require("./less/icons-firefox.less")
//   }
// } else {
//   // 谷歌浏览器
//   if(navigator.userAgent.indexOf("Chrome") != -1) {
//     require("./less/icons.less")
//   } else {
//     // 京麦
//     console.log('京麦------>', )
//     require("./less/icons-ms.less")
//   }
// }

export default {
  name: "ItemDetail",
  data() {
    return {
      allCount:0,
      staVisibleOne: false,
      isAutoAddWaitNode: false,
      isAutoAddWaitNum: 0,
      errorRemindMobile: null,
      isShowNum: false, // 是否显示人数
      isAutoAddTouchNode: false, // 触达
      isAutoAddAnalysisNode: false, // 短信分析
      touchNode: "7",
      touchNodeOptions: [
        {
          label: "短信",
          value: "7",
        },
        {
          label: "富信",
          value: "13",
        },
        {
          label: "卡片短信",
          value: "15",
        },
        {
          label: "咚咚消息",
          value: "16",
        },
      ],
      isSplitCrowd: false,
      checkedWait: false,
      checkedNum: "",
      checked: false,
      quickDailog: false,
      quickForm: {
        nodeConfig: 0,
        namingRules: 0,
        copyRules: 0,
      },
      useQuickForm: {
        nodeConfig: 0,
        namingRules: 0,
        copyRules: 0,
      },
      smsPreview: {
        cusuffix: "",
        content: "",
      },
      smsPreviewShow: false,
      gridVisible: true,
      flag: false,
      names: "",
      showFull: true, //全屏图标控制
      number: "",
      timeType: 1,
      timeType1: 1,
      timeType2: 1,
      fileList: [], //上传的文件列表
      uploadUrl: "", //必选参数，上传的地址
      language: "", //替换文案
      language1: "", //替换文案1
      oneClickReplacement: false, //一键替换文案
      oneClickReplacement1: false,
      exportChat: false, //导入画布
      executionType: "",
      isPremissionShow: false,
      customValue2: "", //人群分析导出备注
      customValue3: "", //人群分析导出备注
      staVisible1: false, //人群效果导出弹窗
      flags: 0,
      approveStatus: "",
      customerBlock: false, //人群超出限制
      marketStatus: "",
      analyzeNodeDTO: {
        name: "",
      },
      customerVisible2: false, //人群分析
      control1: false,
      control2: false,
      control3: false, //咚咚消息
      loading: false,
      isAdvanced: false,
      querycheck: {
        time: "", //执行时间
        totalNumber: "", //总触达人数
        totalmsg: "", //总消耗短信
        send: "", //已发送
        tnbeSent: "", //待发送
        cardTouchCount: 0,
        cardMsgCount: 0,
        cardSendIngNum: 0,
        cardWaitNum: 0,
      },
      feld: false,
      smCountOne: "",
      smCountTwo: "",
      //展开，收起
      openCollapse: false,
      smCount: "",
      //修改名称
      formName: {
        smartMarketingId: "",
        templateId: "",
        activityName: "",
      },
      Timer: "1000",
      statusNum: "",
      aaaaaa: false, //限制
      limitTime: {},
      remindMobile: "",
      tableData: [],
      nodeNumListBatchNum: [],
      batchsettingVisible: false, //批量设置
      batchSure: "", //批量设置
      staVisible: false,
      staValue: "7",
      staValue1: "3",
      staValueOne: "7",
      customValue: "",
      startTime: "", // 统计开始时间
      endTime: "", // 统计结束时间
      startTimeOption: {
        disabledDate: (date) => {
          let endTime = this.endTime;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled =
              time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          let startTime = this.startTime;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled =
              time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      startTime1: "", // 统计开始时间
      endTime1: "", // 统计结束时间
      startTimeOption1: {
        disabledDate: (date) => {
          let endTime = this.endTime1;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled =
              time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
          }
          return isDisabled;
        },
      },
      endTimeOption1: {
        disabledDate: (date) => {
          let startTime = this.startTime1;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled =
              time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      startTime2: "", // 统计开始时间
      endTime2: "", // 统计结束时间
      startTimeOption2: {
        disabledDate: (date) => {
          let endTime = this.endTime2;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled =
              time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
          }
          return isDisabled;
        },
      },
      endTimeOption2: {
        disabledDate: (date) => {
          let startTime = this.startTime2;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled =
              time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      customValue1: "",
      statiType: [
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      statiType1: [
        {
          label: "近3天",
          value: "3",
        },
        {
          label: "近5天",
          value: "5",
        },
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      statiTypeOne: [
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      form: {
        // 官方查询的
        activityTitle: "", // 活动主题
        content: "", // 短信内容
        sendStatus: "", // 发送状态
        sendTimeStart: "", // 发送开始时间
        sendTimeEnd: "", // 发送结束时间
        submitTimeStart: "", // 提交时间开始
        submitTimeEnd: "", // 提交时间结束
        version: 2, // 2.官方 1.平台

        phone: "",
        officialFlag: true, // 活动类型
        sendType: "", // 发送类型
        dataFrom: [], // 1.会员发送 2.订单发送 4.5指定号码发送 6.变量短信发送
        // 官方 end
        size: 10,
        current: 1,
      },
      dialogTemplateVisible: false,
      batchItem: {
        msgCount: 0,
        sumCount: 0,
        batchNum: 0,
        warning: "",
      },
      batchVisible: false,
      foreError: 0,
      imagePicture: require("@/assets/imagesZhi/close.png"),
      id: 0,
      app: "",
      nodeId: "",
      isov: false, //预览小图
      isReadOnly: false,
      edit: true,
      isReset: false,
      isOverview: false,
      formLabelWidth: "70px",
      modify: true,
      modifyOne: false,
      actName: "",
      inputEdit: "",
      inputEdit2: "",
      execute: false, //立即执行
      executeOne: false, //周期执行
      executeTwo: false, //定时执行
      // execform:{
      //   remindTel:''
      // },
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() > this.defaultTime + 8.64e7 ||
            time.getTime() < Date.now() - 8.64e7
          );
        },
        selectableRange: "9:00:00 - 10:55:59",
      },
      pickerOptions2: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > Date.now() + 8.64e7 * 90
          );
        },
        selectableRange: "9:00:00 - 19:55:59",
      },
      execform: {
        id: 0,
        executionType: 0,
        timingExecutionTime: "",
        cycleExecutionType: 0,
        cycleDay: 0,
        cycleDayWeekly: [],
        cycleDayMonthly: [],
        cycleExecutionTime: "00:00:00",
        datetime: [],
        cycleStartTime: "",
        cycleEndTime: "",
      },
      cycleDayWeeklys: [
        {
          value: 2,
          label: "周一",
        },
        {
          value: 3,
          label: "周二",
        },
        {
          value: 4,
          label: "周三",
        },
        {
          value: 5,
          label: "周四",
        },
        {
          value: 6,
          label: "周五",
        },
        {
          value: 7,
          label: "周六",
        },
        {
          value: 1,
          label: "周日",
        },
      ],
      cycleDayMonthlys: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      option1: [
        { label: "立即执行", value: 0 },
        { label: "定时执行", value: 1 },
        { label: "周期执行", value: 2 },
      ],
      diagramData: {
        nodeDataArray: [],
        linkDataArray: [],
      },
      activeName: [1, 2, 3, 4, 5, 6],
      icons: [
        {
          title: "目标客户",
          chliden: [
            {
              icon: "vip",
              name: "客户分群",
              index: 1,
            },
            {
              icon: "order",
              name: "订单筛选",
              index: 11,
            },
            {
              icon: "presell",
              name: "预售订单",
              index: 12,
            },
          ],
        },
        {
          title: "目标筛选",
          chliden: [
            {
              icon: "merge",
              name: "合并",
              index: 2,
            },
            {
              icon: "extraction",
              name: "抽取",
              index: 3,
            },
            {
              icon: "intersection",
              name: "交集",
              index: 4,
            },
            {
              icon: "exclude",
              name: "排除",
              index: 5,
            },
            {
              icon: "unique",
              name: "排重",
              index: 6,
            },
          ],
        },
        {
          title: "执行方式",
          chliden: [
            {
              icon: "await",
              name: "等待",
              index: 10,
            },
          ],
        },
        {
          title: "触达方式",
          chliden: [
            {
              icon: "msg",
              name: "短信",
              index: 7,
            },
            //Note---添加富信节点
            {
              icon: "medium",
              name: "富信",
              index: 13,
            },
            {
              icon: "card",
              name: "卡片短信",
              index: 15,
            },
            //Note----END
          ],
        },
        {
          title: "营销分析",
          chliden: [
            {
              icon: "analyze__msg",
              name: "短信分析",
              index: 8,
            },
          ],
        },
      ],
      control: [
        {
          event: "reset",
          icon: "reset",
          name: "恢复编辑",
        },
        {
          icon: "zoomOut",
          name: "放大",
        },
        {
          icon: "zoomIn",
          name: "缩小",
        },
        {
          icon: "copy",
          name: "复制",
        },
        {
          icon: "delete",
          name: "删除",
        },
        {
          icon: "saveAs",
          name: "另存为模板",
        },
        {
          icon: "help",
          name: "使用帮助",
        },
      ],
      currentNode: null,
      currentLink: null,
      isOverview: false,
      isov: false,
      /**另存为弹框 */
      dialogTemplateFormVisible: false,
      formTemplate: {
        intelligentMarketingId: "",
        name: "",
        picUrl: "",
      },
      rulest: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      /***合并 */
      mergeVisible: false,
      /***排除 */
      excludeVisible: false,
      /***交集 */
      intersectionVisible: false,
      /***抽取 */
      extractionVisible: false,
      /***排重 */
      uniqueVisible: false,
      /***订单筛选 */
      orderVisible: false,
      /***预售订单 */
      presellVisible: false,
      /***人群分析 */
      customerVisible: false,
      vipVisible: false, // 会员分群弹窗节点
      msgVisible: false, // 短信弹窗
      nodeNumListBatchNumOne: [],
      msgMore: "",
      mediumVisible: false, //Note富信弹窗
      cardVisible: false,
      analyzeVisible: false, // 短信分析弹窗节点
      awaitVisible: false, // 等待节点
      execVisible: false, // 正式发送节点
      marketingDetail: null,
      isTest: true,
      isExec: true,
      resetdata: 5,
      testSmsQuery: {
        mediaWarning: "",
        cardTouchCount: "",
        cardMsgCount: "",
        cardWarning: "",
      },
      hasSms: false,
      hasMedialSms: false,
      hasCardSms: false,
      isReplace: false, //一键替换文案
      showNodeSetting: false,
      replaceCheck: 7,
      // 控制侧边栏收缩
      asideStatus: false,
      aside_open_close: false,
    };
  },
  created() {
    // 复制画布添加提示
    if (this.$route.query.form && this.$route.query.form == "copy") {
      this.showCopyTip();
      const query = JSON.parse(JSON.stringify(this.$route.query));
      delete query.form;
      this.$router.replace({ query });
    }
    this.$data.id = sessionStorage.getItem("markId")
      ? sessionStorage.getItem("markId")
      : Number(this.$route.query.id);
    //Note已结束或者正式执行中就调用
    if (
      this.$route.query.statusNum == 2 ||
      sessionStorage.getItem("statusNames") == 2
    ) {
      // this.getFinishTaskData()
      this.testAllOne();
    }
    if (
      this.$route.query.statusNum == 4 ||
      sessionStorage.getItem("statusNames") == "4"
    ) {
      this.testAll();
    }
    this.$data.actName = sessionStorage.getItem("markNum")
      ? sessionStorage.getItem("markNum")
      : sessionStorage.getItem("name")
      ? sessionStorage.getItem("name")
      : this.$route.query.actName;
    this.$data.statusNum = sessionStorage.getItem("statusNames")
      ? sessionStorage.getItem("statusNames")
      : this.$route.query.statusNum;
    this.$data.editStatus = this.$route.query.status || "";
    this.$data.executionType = this.$route.query.executionType;
    //进入页面中调取的列表
    this.setinit();
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    getSettingMoreDiabled() {
      return (
        this.statusNum == 1 ||
        this.statusNum == 5 ||
        this.statusNum == 3 ||
        this.statusNum == 4 ||
        this.statusNum == 2 ||
        this.statusNum == 8 ||
        this.statusNum == 7
      );
    },
    // 画布配置权限
    isCanCanvasConfig() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:config");
      return isCan;
    },
  },
  watch: {
    "execform.timingExecutionTime": {
      handler(newValue, oldValue) {
        if (
          (newValue &&
            oldValue &&
            newValue.substring(0, 10) != oldValue.substring(0, 10)) ||
          (newValue && !oldValue)
        ) {
          var val = newValue.substring(0, 10);
          var nowTime10 = this.$getNowDate();
          if (this.maxLimitDate) {
            nowTime10 = this.maxLimitDate;
          }
          var time1 = nowTime10.substring(0, 10);
          var time2 = nowTime10.substring(11, 19);
          var maxLimit = ""; // 活动节点最小等待时间
          var hmsLimit = ""; // 活动节点最小等待时间时分秒

          var startTime = this.limitTime.startTime;
          var endTime = this.limitTime.endTime;

          var arr = time2.split(":");
          var endArr = endTime.split(":");

          // 最晚可以选到时间
          if (arr[0] > endArr[0]) {
            time2 = endTime;
          } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
            time2 = endTime;
          } else if (
            arr[0] == endArr[0] &&
            arr[1] == endArr[1] &&
            arr[2] >= endArr[2]
          ) {
            time2 = endTime;
          }

          if (val == time1) {
            this.execform.timingExecutionTime = val + " " + time2;
            // this.pickerOptions.selectableRange = time2 + " - " + endTime;
          } else {
            // this.execform.timingExecutionTime = val + ' ' + startTime;
            // this.pickerOptions.selectableRange = startTime + " - " + endTime;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    permissions(nVal, oVal) {
      if (nVal.indexOf("hide:crowdAnalysis") != "-1") {
        let params = {
          icon: "customer__msg",
          name: "人群分析",
          index: 14,
        };
        this.icons[4].chliden.push(params);
      }
      //一键替换文案权限
      if (nVal.indexOf("hide:replaceContent") != "-1") {
        this.isReplace = true;
      }
    },
    timeType(nVal) {
      if (nVal == 1) {
        this.clearEffectTime();
      } else {
        this.customValue = "";
      }
    },
    timeType1(nVal) {
      if (nVal == 1) {
        this.clearEffectTime1();
      } else {
        this.customValue1 = "";
      }
    },
  },
  components: {
    FullScreen,
    diagram,
    mergeDialog,
    membershipDialog,
    smsSendDialog,
    excludeDialog,
    intersectionDialog,
    extractionDialog,
    uniqueDialog,
    smsAnalysis,
    awaitDialog,
    execDialog,
    TemplateDialog,
    batchsettingDialog,
    orderDialog,
    presellDialog,
    mediumDialog, //富信节点
    cardDialog,
    generate,
    generate1,
    generate2,
    customerDialog,
    smsInfo,
    nodeSetting,
    ToolHeader,
    ToolBar,
  },
  async mounted() {
    //监听全屏图标
    document.addEventListener("fullscreenchange", (event) => {
      if (document.fullscreenElement) {
        this.showFull = false;
      } else {
        this.showFull = true;
      }
    });
    this.handleShowPremission();
    const { data: res } = await mnode.getsendTime();
    this.pickerOptions.selectableRange = res.startTime + " - " + res.endTime;
    this.getLimitTime();
    this.selint();
    this.getSetting();
  },
  methods: {
     //包含
     includeMode(){
      let diagram = this.$refs.diag.diagram;
      diagram.toolManager.dragSelectingTool.isPartialInclusion = false;
      diagram.toolManager.dragSelectingTool.delay = 10; //框选
    },
    //相交
    intersectionMode(){
      let diagram = this.$refs.diag.diagram;
      diagram.toolManager.dragSelectingTool.isPartialInclusion = true;
      diagram.toolManager.dragSelectingTool.delay = 10; //框选
    },
    //拖动
    dragMode(){
      let diagram = this.$refs.diag.diagram;
      diagram.toolManager.dragSelectingTool.delay = 800;
    },
    // 侧边栏收缩与展开
    asidechange() {
      this.asideStatus = !this.asideStatus;
      if (this.asideStatus) {
        setTimeout(() => {
          this.aside_open_close = true;
        }, 300);
      } else {
        setTimeout(() => {
          this.aside_open_close = false;
        }, 300);
      }
    },
    //一键命名
    oneClickNaming() {
      autoSetBatchNodeNames({ activityId: this.$data.id }).then((res) => {
        const { message } = res;
        const { code } = res;
        if (code == 0) {
          this.setinit();
          this.$message.error(message);
        } else {
          this.setinit();
          this.$message.success(message);
        }
      });
    },
    //取消
    sureQuickChance() {
      if (!this.checked) {
        this.getSetting();
      }
      this.quickDailog = false;
    },
    //后端多加一个字段，控制是否显示正式执行
    getStatus() {
      mnode.getStatus(this.$data.id).then((res) => {
        if (this.checked == false) {
          this.checkedNum = 0;
        } else {
          const { data } = res;
          if (!data.lastTestTime && this.statusNum == 0) {
            this.checkedNum = 0;
          } else {
            //正式执行后
            if (
              this.statusNum == 2 ||
              this.statusNum == 5 ||
              this.statusNum == 0
            ) {
              this.checkedNum = 0;
            } else {
              this.checkedNum = 1;
            }
          }
        }
      });
    },
    checkedChange(val) {
      this.checked = val;
      if (val) {
        this.checkedNum = 1;
      } else {
        this.checkedNum = 0;
      }
    },
    checkedChangeWaits(val) {
      if (val) {
        this.isAutoAddWaitNum = 1;
      } else {
        this.isAutoAddWaitNum = 0;
      }
    },
    getSetting() {
      getSetting().then((res) => {
        if (res.code == 1) {
          this.quickForm.nodeConfig = res.data.nodeUpType;
          this.quickForm.namingRules = res.data.nodeNameType;
          this.quickForm.copyRules = res.data.copyType;
          this.useQuickForm.nodeConfig = res.data.nodeUpType;
          this.useQuickForm.namingRules = res.data.nodeNameType;
          this.useQuickForm.copyRules = res.data.copyType;
          this.checkedNum = res.data.recoverNeedTestAgain;
          this.isAutoAddWaitNum = res.data.isAutoAddWaitNode;
          this.isSplitCrowd = res.data.isSplitCrowd == 1 ? true : false;
          if (this.checkedNum == 1) {
            this.checked = true;
          } else {
            this.checked = false;
          }
          if (this.isAutoAddWaitNum == 1) {
            this.isAutoAddWaitNode = true;
          } else {
            this.isAutoAddWaitNode = false;
          }
          this.isShowNum = res.data.isShowNum == 1 ? true : false;
          this.errorRemindMobile = res.data.errorRemindMobile;
          this.isAutoAddTouchNode =
            res.data.isAutoAddTouchNode == 1 ? true : false;
          this.isAutoAddAnalysisNode =
            res.data.isAutoAddAnalysisNode == 1 ? true : false;
          this.touchNode = String(res.data.touchNode);
          this.getStatus();
        }
      });
    },
    //快捷操作
    openQuick() {
      this.quickForm.nodeConfig = this.useQuickForm.nodeConfig;
      this.quickForm.namingRules = this.useQuickForm.namingRules;
      this.quickForm.copyRules = this.useQuickForm.copyRules;
      this.quickDailog = true;
      this.getSetting();
    },
    quickConfig() {
      if (this.isAutoAddAnalysisNode && !this.isAutoAddTouchNode) {
        return this.$message.error("请先勾选触达节点");
      }
      this.useQuickForm.nodeConfig = this.quickForm.nodeConfig;
      this.useQuickForm.namingRules = this.quickForm.namingRules;
      this.useQuickForm.copyRules = this.quickForm.copyRules;
      let fromData = {
        nodeUpType: this.useQuickForm.nodeConfig,
        nodeNameType: this.useQuickForm.namingRules,
        copyType: this.useQuickForm.copyRules,
        recoverNeedTestAgain: this.checkedNum,
        isAutoAddWaitNode: this.isAutoAddWaitNum,
        isAutoAddTouchNode: this.isAutoAddTouchNode ? 1 : 0,
        isAutoAddAnalysisNode: this.isAutoAddAnalysisNode ? 1 : 0,
        touchNode: this.touchNode,
        isSplitCrowd: this.isSplitCrowd ? 1 : 0,
        isShowNum: this.isShowNum ? 1 : 0,
        errorRemindMobile: this.errorRemindMobile,
      };
      startActivity(fromData).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
      this.quickDailog = false;
    },
    sureQuick() {
      if(!this.isCanCanvasConfig){
        this.quickDailog = false;
        return
      }
      if (this.checked) {
        this.quickDailog = false;
        this.$confirm(
          "若不进行测试执行，则无法预估发送人数和资源扣减情况，建议测试执行哦~",
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            iconClass: "el-icon-warning",
          }
        )
          .then(() => {
            this.quickConfig();
            this.getStatus();
          })
          .catch(() => {
            this.quickDailog = false;
            this.$message.info("已取消删除");
            this.getStatus();
            this.getSetting();
          });
      } else {
        this.quickConfig();
      }
    },
    mouseEvents(e, n) {
      if (n.data.isSaveContent == (0 || false)) {
        let diagram = this.$refs.diag.diagram;
        //鼠标移入去除
        // let node=diagram.findNodeForKey(n.data.smartMarketingNodeId)
        // node.isSelected=false
        let model = this.model();
        model.setDataProperty(
          model.findNodeDataForKey(n.data.nodeId),
          "errorDesc",
          "请设置节点"
        );
        this.currentNode = n;
        // let node = this.currentNode;
        // console.log('444444',node);
        // let category = node.data.category;
        // this.$data[category + "Visible"] = !this.$data[category + "Visible"];
      } else {
        let diagram = this.$refs.diag.diagram;
        let model = this.model();
        model.setDataProperty(
          model.findNodeDataForKey(n.data.nodeId),
          "errorDesc",
          n.data.errorDesc == null ? "" : n.data.errorDesc
        );
        model.setDataProperty(
          model.findNodeDataForKey(n.data.nodeId),
          "isSelected",
          false
        );
        diagram.isSelectionEnabled = false; // 开启拖动选择功能
        // diagram.selectionManager.multiple = false; // 支持多选
      }
    },
    //鼠标移入显示隐藏
    checkouts(val) {
      this.names = val.name;
    },
    checkouts1() {
      this.names = "";
    },
    //引用模板
    dialogVisiTemp() {
      this.buriedPoint(9, "引用模板", "", "");
      this.dialogTemplateVisible = true;
    },
    //Note全屏功能
    toggleFull() {
      //判断当前浏览器是否可全屏
      if (!screenfull.isEnabled) {
        this.$message({
          type: "warning",
          message: "当前不可全屏",
        });
        return false;
      }
      screenfull.toggle();
      this.showFull = false;
    },
    //退出全屏
    toggleFull1() {
      screenfull.toggle();
      this.showFull = true;
    },
    diagramToggleFull() {
      if (this.showFull) {
        this.toggleFull();
      } else {
        this.toggleFull1();
      }
    },
    //还原
    defaultChange() {
      let diagram = this.$refs.diag.diagram;
      diagram.scale = 1;
    },
    beforeUpload(file, fileList) {
      // 选完上传的文件,开启进度条
      // const fileSize = file.size / 1024 / 1024 < 50;
      // if (!fileSize) {
      //   this.message.warning("上传模板大小不能超过 50MB!");
      //   return  false;
      // }
      console.log("file", file);
      console.log("file2312312", fileList);
      this.fileList = fileList;
      let formData = new FormData();
      formData.append("file", file);
      console.log("formData:", formData);
      uploadMobile(formData).then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.$message.success("上传成功！");
          let paramsSure = {
            params: res.data.data,
            name: file.name,
          };
          this.fileList.push(paramsSure);
          //上传成功之后，返回对应的参数，成功和失败的参数
          // this.selint();
          // this.exportChat = false
        } else {
          this.$message.error(res.message);
        }
      });
      return false;
    },
    staValueChange(val) {
      if (val) {
        this.customValue = "";
        this.clearEffectTime();
      }
    },

    staValueChange1(val) {
      if (val) {
        this.customValue1 = "";
        this.clearEffectTime1();
      }
    },

    //咚咚效果导出
    staValueChangeOne(val) {
      if (val) {
        this.customValue = "";
        this.clearEffectTime2();
      }
    },

    // 清除效果数据时间
    clearEffectTime() {
      this.startTime = "";
      this.endTime = "";
    },

    // 清除效果数据时间
    clearEffectTime1() {
      this.startTime1 = "";
      this.endTime1 = "";
    },

    // 清除效果数据时间
    clearEffectTime2() {
      this.startTime2 = "";
      this.endTime2 = "";
    },
    //下载模板
    downTemplate() {
      let url = "";
      let fileName = "";
      url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/excel_import_send.xlsx";
      fileName = "excel_variate_send.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    //替换文案确定
    async replaceChange() {
      //1.敏感词汇检测
      const checkResult = await this.$wordCheck({ content: this.language1 });
      if (checkResult.code != 1) {
        return this.$message.error(checkResult.message);
      } else {
        let params = {
          marketingId: this.$data.id,
          findText: this.language,
          replaceText: this.language1,
          replaceNodeType: this.replaceCheck,
        };
        //弹框局部加载
        let loadingInstance = this.$loading({
          target: ".publishDialog",
          lock: true,
          text: "加载中",
        });
        //调用替换接口
        replaceContents(params)
          .then((res) => {
            if (res.code === 1) {
              this.number = res.data; //完成多少处替换
              this.oneClickReplacement = false;
              this.oneClickReplacement1 = true;
              loadingInstance.close();
              this.setinit();
            } else {
              this.$message.error(res.message);
              loadingInstance.close();
            }
          })
          .catch(() => {});
      }
    },
    //导入画布
    importCanvas() {
      this.exportChat = true;
    },
    //一键替换文案
    replacement() {
      this.buriedPoint(9, "一键替换文案", "", "");
      this.language = "";
      this.language1 = "";
      this.oneClickReplacement = true;
    },
    handleShowPremission() {
      if (
        this.permissions &&
        this.permissions.indexOf("hide:crowdAnalysis") != "-1"
      ) {
        //显示和屏蔽人群
        let params = {
          icon: "customer__msg",
          name: "人群分析",
          index: 14,
        };
        this.icons[4].chliden.push(params);
      }
      //一键替换文案权限
      if (
        this.permissions &&
        this.permissions.indexOf("hide:replaceContent") != "-1"
      ) {
        this.isReplace = true;
      }
    },
    rulesOpitonChange(e) {
      if (e == 1) {
        this.buriedPoint(9, "营销效果导出", "", "");
        this.isRecord();
      } else if (e == 2) {
        // this.control2 = true;
        this.buriedPoint(9, "人群分析导出", "", "");
        this.staVisible1 = true;
        this.flags = 1;
      } else if (e == 3) {
        exportCanvas({ marketingId: this.$data.id }).then((res) => {
          if (res.code == 1) {
            var blob = new Blob([res.blob]);
            var link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = "导出画布(仅排重)模板.xls";
            link.click();
            window.URL.revokeObjectURL(link.href);
          } else {
            this.$message.error(res.message);
          }
        });
      } else if (e == 4) {
        //咚咚效果导出
        this.buriedPoint(9, "咚咚效果导出", "", "");
        this.isRecord1();
      }
    },

    //人群分析节点更新
    saveCustomer() {
      let obj = {
        nodeId: this.nodeId,
        name: this.analyzeNodeDTO.name,
      };
      mnode.updateDetail(obj).then((res) => {
        if (res.code == 1) {
          this.customerVisible2 = false;
          this.changedName(obj);
        }
      });
    },
    //自动布局
    usingTutorials1() {
      let diagram = this.$refs.diag.diagram;
      var nodeLayoutData = diagram.model.nodeDataArray;
      if (!nodeLayoutData) {
        this.$message.error("不存在节点，");
      }
      diagram.layoutDiagram(true);
      var layoutData = [];
      var layoutNodes = [];
      nodeLayoutData.forEach((v, index) => {
        let coordinateLayout = nodeLayoutData[index].coordinate.split(" ");
        let coordinateLocLayout = `${parseInt(coordinateLayout[0])},${parseInt(
          coordinateLayout[1]
        )}`;
        if (
          nodeLayoutData[index].smartMarketingNodeId ||
          nodeLayoutData[index].coordinate
        ) {
          layoutData.push(coordinateLocLayout);
          layoutNodes.push(nodeLayoutData[index].nodeId);
        }
      });
      mnode
        .updateCoordinateBatch({
          intelligentMarketingNodeIds: layoutNodes,
          coordinates: layoutData,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.error(res.message);
          } else [];
        });
    },
    hideGrid() {
      this.gridVisible = !this.gridVisible;
      let diagram = this.$refs.diag.diagram;
      diagram.grid.visible = this.gridVisible;
      // console.log(diagram);
    },
    revoke() {
      mnode.quash({ marketingId: this.$data.id }).then((res) => {
        if (res.code === 1) {
          console.log("撤回操作");
          this.setinit();
        }
      });
    },
    //Note---恢复快捷键
    redo() {
      mnode.recovery({ smartMarketingId: this.$data.id }).then((res) => {
        if (res.code === 1) {
          console.log("恢复操作");
          this.setinit();
        }
      });
    },
    // 预览短信
    openMsg() {
      let diagram = this.$refs.diag.diagram;
      let list = diagram.selection;
      let nodeNumListBatch = [];
      list.each((nodeOrLink, index) => {
        if (nodeOrLink.data.category) {
          nodeNumListBatch.push(nodeOrLink.data);
        }
      });
      let node = nodeNumListBatch[0];
      console.log("node", node);
      let params = {
        nodeId: node.nodeId,
      };
      mnode.getNode(params).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.smsPreview.cusuffix = res.data.smsNode.jdSmsSuffix;
          this.smsPreview.content = res.data.smsNode.content;
          this.smsPreviewShow = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    saveAstemplateClick() {
      this.dialogTemplateFormVisible = true;
    },
    //删除
    deleteOne() {
      if (!this.$data.isReadOnly) {
        let diagram = this.$refs.diag.diagram;
        if (diagram.commandHandler.canDeleteSelection()) {
          diagram.commandHandler.deleteSelection();
        } else {
          this.$message.error("请选择要删除的节点！");
        }
      } else {
        this.readOnly();
      }
    },
    // 撤销
    revokeBtn() {
      if (!this.$data.isReadOnly) {
        this.revoke();
      } else {
        this.readOnly();
      }
    },
    // 恢复
    redoBtn() {
      if (!this.$data.isReadOnly) {
        this.redo();
      } else {
        this.readOnly();
      }
    },
    afterNodeClick(node) {
      if (this.$data.isReadOnly) {
        this.readOnly();
        return;
      }
      let diagram = this.$refs.diag.diagram;
      let list = diagram.selection;
      let nodeNumListBatch = [];
      list.each((nodeOrLink, index) => {
        if (nodeOrLink.data.category) {
          nodeNumListBatch.unshift(nodeOrLink.data);
        }
      });
      console.log("nodeNumListBatch: ", nodeNumListBatch);
      let nodeIds = nodeNumListBatch.map((item) => item.nodeId);
      let coordinates;
      let oneAfterType = [2, 4, 5, 6];
      if (oneAfterType.includes(node.type)) {
        let xyList = nodeNumListBatch.map((item) => item.coordinate.split(" "));
        // let xMax = Math.max(...xyList.map(item=>Number(item[0])));
        // let yMax = Math.max(...xyList.map(item=>Number(item[1])));
        // let yMin = Math.min(...xyList.map(item=>Number(item[1])));
        const [xMax, yMax, yMin] = xyList.reduce(
          ([xMax, yMax, yMin], item) => {
            const [x, y] = item.map(Number);
            return [Math.max(xMax, x), Math.max(yMax, y), Math.min(yMin, y)];
          },
          [-Infinity, -Infinity, Infinity]
        );
        let x = (xMax * 100 + 20000) / 100;
        let y = ((yMax * 100 + yMin * 100) / 200).toFixed(2);
        coordinates = [x + "," + y];
      } else {
        coordinates = nodeNumListBatch.map((item) => {
          let xy = item.coordinate.split(" ");
          let x = (Number(xy[0] * 100) + 20000) / 100;
          let y = xy[1];
          return x + "," + y;
        });
      }
      let params = {
        type: node.type,
        name: node.name,
        nodeIds,
        coordinates,
        marketingId: this.$data.id,
      };
      mnode.addPostNode(params).then((res) => {
        if (res.code == 1) {
          this.setinit();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //分群刷新
    changeInit() {
      let diagram = this.$refs.diag.diagram;
      //获取到选择多节点的数据
      var nodeOrLinkList = diagram.selection.toArray().map(node => node.data);;
      var nodeNumList = [];
      if(nodeOrLinkList){
        nodeNumList = [...nodeOrLinkList]
      }
      this.setinit(nodeNumList);
    },
    closeStaVisible() {
      this.staVisible = false;
      this.approveStatus = "";
    },
    closeStaVisible1() {
      this.staVisible1 = false;
      this.approveStatus = "";
    },
    closeStaVisible2() {
      this.staVisibleOne = false;
      this.approveStatus = "";
    },
    //鼠标拖动复制
    SelectionCopied(e) {
      console.log("5454545454", e);
      //Note新逻辑
      let diagram = this.$refs.diag.diagram;
      if (this.$data.isReadOnly) {
        this.readOnly();
        return;
      }
      /****oldeNodekay,存放旧的节点key 和loc的关系
        {
           "210 310": -18,
           "558 276": -19
         }
      ***/
      var oldNodekey = {};
      var nodeOrLinkList = diagram.selection;
      var nodeNumList = [];
      nodeOrLinkList.each((nodeOrLink, index) => {
        nodeNumList.push(nodeOrLink.data);
      });
      var locMap = {};
      if (nodeNumList.length > 1) {
        if (nodeNumList.find((item) => item.category == "targetGroups")) {
          this.$message.error("目标人群节点不能复制！");
          return;
        }
        //找出相同坐标的节点nodeList;
        // 相同位置节点其中一个偏移
        // var loc = go.Point.stringify(n.location.offset(50, 50));
        // locMap[n.data.name] = loc;
        // diagram.model.setDataProperty(n.data, "coordinate", loc);
        e.subject.each(function (n) {
          if (n instanceof go.Node) {
            //判断是不是节点
            var loc = go.Point.stringify(n.location.offset(200, 200));
            locMap[n.data.name] = loc;
            diagram.model.setDataProperty(n.data, "coordinate", loc);
            //获取节点坐标，将坐标和key关系对应
            let locarr = loc.split(" ");
            var locfro = `${parseInt(locarr[0])},${parseInt(locarr[1])}`;
            oldNodekey[locfro] = n.data.key;
          } else {
            console.log(n.data, "复制的线");
          }
        });
        // 选中复制多个
        var nodeIds = [];
        var coordinates = [];
        nodeNumList.forEach((v, index) => {
          console.log("遍历选择集合", nodeNumList[index]);
          if (nodeNumList[index].nodeId) {
            nodeIds.push(JSON.stringify(nodeNumList[index].nodeId));
            let coordinate = nodeNumList[index].coordinate.split(" ");
            var coordinateLoc = `${parseInt(coordinate[0])} ${parseInt(
              coordinate[1]
            )}`;
            coordinates.push(coordinateLoc);
          }
        });
        // console.log(diagram.model.toJson());  打印数据
        //Note---获取实际节点坐标
        var param = {
          nodeIds,
          coordinateList: coordinates,
          // keyIds: oldNodekey, //KEY对应的坐标
          // offsetAbscissa: 50, // 横坐标偏移量
          // offsetOrdinate: 50, // 纵坐标偏移量
        };
        mnode.copyBatchNode(param).then((res) => {
          if (res.code === 1) {
            let showTip = false;
            let showRichTip = false;
            nodeNumList.forEach((item) => {
              if (item.category == "medium" || item.category == "card") {
                showRichTip = true;
              }
              if (item.category == "msg") {
                showTip = true;
              }
            });
            if (showTip || showRichTip) {
              if (showTip && showRichTip) {
                this.showSmsTip();
                setTimeout(() => {
                  this.showRichTip();
                }, 3000);
              }
              // 短信
              if (showTip && !showRichTip) {
                this.showSmsTip();
              }
              // 富信、卡片
              if (showRichTip && !showTip) {
                this.showRichTip();
              }
            }
            var list = res.data;
            list.forEach((e, v) => {
              //从后台拿到coordinate 找到旧的节点key
              var newloca = list[v].coordinate;
              // let newlocArr = newloc.split(",");
              // var newloca = `${parseInt(newlocArr[0])} ${parseInt(
              //   newlocArr[1]
              // )}`;
              console.log("oldNodekey", oldNodekey);
              console.log("newloca", newloca);
              console.log(
                "复制出来的node旧的key",
                oldNodekey[newloca],
                "改成",
                list[v].smartMarketingNodeId
              );
              // 通过旧的key 找到节点
              var node = diagram.findNodeForKey(oldNodekey[newloca]);
              var nodeData = node.data;
              nodeData.text = list[v].name;
              nodeData.name = list[v].name;
              nodeData.nodeId = list[v].id;
              nodeData.marketingId = list[v].marketingId;
              nodeData.category = list[v].category;

              if (nodeData.category == "analyze") {
                console.log("65665464654", nodeData.category);

                nodeData.isSaveContent = list[v].isSaveContent;
              } else {
                console.log("65665464654", nodeData.category, 66665555565);
                //复制内容是否是保存状态问题处理
                if (this.quickForm.copyRules == 0) {
                  nodeData.isSaveContent = true;
                } else {
                  nodeData.isSaveContent = false;
                }
              }
              nodeData.type = list[v].type;
              // nodeData.executionStatus = list[v].executionStatus;
              nodeData.venderId = list[v].venderId;

              //让角标去除
              nodeData.executionStatus = list[v].executionStatus = "";
              nodeData.errorDesc = list[v].errorDesc = "";

              // // nodeData.coordinate = list[v].coordinate;
              // nodeData.isShowCount = list[v].isShowCount;
              // nodeData.couponStatus = list[v].couponStatus;
              console.log("66666666", nodeData);

              if (this.quickForm.copyRules == 0) {
                nodeData.isSaveContent = true;
              } else {
                nodeData.isSaveContent = false;
              }

              //更新复制出来的节点;
              diagram.model.updateTargetBindings(nodeData);
              //让节点的key更新成后台的smartMarketingNodeId;
              diagram.model.setKeyForNodeData(nodeData, list[v].id);
            });
            console.log("oldNodekey", oldNodekey);
          } else {
            this.$message.error(res.message);
          }
        });
        //Note----新节点处理
        return;
      } else {
        //Note----复制新逻辑
        var params = null;
        e.subject.each(function (n) {
          if (n instanceof go.Node) {
            console.log(n.data, "复制的节点1111");
            //判断是不是节点
            //判断非人群分组节点
            if (n.data && n.data.category !== "targetGroups") {
              var loc = go.Point.stringify(n.location.offset(200, 200));
              // locMap[n.data.name] = loc;
              diagram.model.setDataProperty(n.data, "coordinate", loc);
              //获取节点坐标，将坐标和key关系对应
              // let locarr = loc.split(" ");
              // var locfro = `${parseInt(locarr[0])},${parseInt(locarr[1])}`;
              // oldNodekey[locfro] = n.data.key;
            }
            params = { ...n.data };
          } else {
            console.log(n.data, "复制的线");
          }
        });
        if (params.category !== "targetGroups") {
          params.smartMarketingId = this.$data.id;
          // let obj = {
          //     smartMarketingId: params.smartMarketingId,
          //     smartMarketingNodeId: params.smartMarketingNodeId,
          //     coordinate: params.coordinate,
          // };
          let key = params.key;
          mnode.copyNode(params.nodeId, params.coordinate).then((res) => {
            if (res.code === 1) {
              // 短信
              if (params.category == "msg") {
                this.showSmsTip();
              } else if (
                params.category == "medium" ||
                params.category == "card"
              ) {
                this.showRichTip();
              }
              var node1 = diagram.selection.first().data;
              let data = JSON.parse(JSON.stringify(node1));

              console.log(data, "666666");

              data.nodeId = data.key = res.data;
              /************
                * /根据key查到节点的对象
                 myDiagram.findNodeForKey(复制的节点key);
                //根据nodedata更新节点数据
                 myDiagram.model.updateTargetBindings(nodeData);
                //根据nodedata更新节点的单个属性
                myDiagram.model.setDataProperty(n.data, 'loc', loc);
                //根据nodedata更新节点的key
                myDiagram.model.setKeyForNodeData(n.data,后台返回的nodeId);
               *
               */

              var node = diagram.findNodeForKey(key);
              var keyDate = node.data;
              keyDate.nodeId = res.data;
              keyDate.executionStatus = "";
              keyDate.errorDesc = "";
              keyDate.isSaveContent = keyDate.isSaveContent;
              console.log("5555555", keyDate, this.quickForm.copyRules);

              if (keyDate.category == "analyze") {
                keyDate.isSaveContent = keyDate.isSaveContent;
              }

              if (this.quickForm.copyRules == 1) {
                if (keyDate.isSaveContent == false) {
                  keyDate.isSaveContent = false;
                }
              }
              if (this.quickForm.copyRules == 0) {
                if (keyDate.isSaveContent == true) {
                  keyDate.isSaveContent = true;
                }
              }

              // if (keyDate.category == "analyze") {
              //   keyDate.isSaveContent = keyDate.isSaveContent;
              // } else {
              //   // if(this.quickForm.copyRules == 0){
              //   //   console.log('54545454',this.quickForm.copyRules );

              //   //   keyDate.isSaveContent = true;
              //   // }else{
              //   //   console.log('11111111',this.quickForm.copyRules );
              //   //   keyDate.isSaveContent = false;
              //   // }
              // }
              diagram.model.updateTargetBindings(keyDate);
              //让节点的key更新成后台的nodeId;
              diagram.model.setKeyForNodeData(keyDate, data.nodeId);

              //京东----------1.12，根据快捷操作复制

              if (this.useQuickForm.copyRules == 1) {
                if (keyDate.category == "presell") {
                  this.setinit();
                } else if (keyDate.category == "order") {
                  this.setinit();
                } else if (keyDate.category == "vip") {
                  this.setinit();
                }
              }
            } else {
              // this.$message.error("目标人群节点不能复制！");
              this.$message.error(res.message);
              let model = this.model();
              e.subject.each(function (n) {
                model.removeLinkData(n.data);
                model.removeNodeData(n.data);
                model.commitTransaction("updateStatus");
              });
            }
          });
        } else {
          this.$message.error("目标人群节点不能复制！");
        }
      }
    },
    // 判断有无短信批次
    isRecord() {
      this.staVisible = true;
    },
    //咚咚效果导出
    isRecord1() {
      this.staVisibleOne = true;
    },
    testAll() {
      this.feld = false;
      mnode
        .getExecNodeAllResultCount({ marketingId: this.$data.id })
        .then((val) => {
          this.allCount = val.data.allCount; // 人群数量汇总预估
          this.batchItem.batchNum = val.data.batchNum;
          this.batchItem.msgCount = val.data.msgCount;
          this.batchItem.sumCount = val.data.sumCount;
          this.batchItem.warning = val.data.warning;
          this.testSmsQuery = {
            touchCount: val.data.touchCount, // 普通短信触达人数
            msgCount: val.data.msgCount, // 普通短信消耗短信数
            mediaTouchCount: val.data.mediaTouchCount, // 富信触达人数
            mediaMsgCount: val.data.mediaMsgCount, // 富信消耗短信数
            cardTouchCount: val.data.cardSmsTouchCount, // 富信触达人数
            cardMsgCount: val.data.cardSmsMsgCount, // 富信消耗短信数
            warning: val.data.warning, // 普通短信余额
            mediaWarning: val.data.mediaWarning, // 富信余额
            cardWarning: val.data.cardSmsWarning, // 富信余额
          };
          this.smCount = val.data.sumCount;
          this.smCountTwo = val.data.msgCount;
          this.smCountOne = val.data.warning;

        });
    },
    limitInput1(event) {
      var value = event.target.value;
      if (value == "0") {
        event.target.value = "";
      } else if (value >= 30) {
        event.target.value = 30;
      } else {
        event.target.value = value.replace(/[^\d]/g, "");
      }
      return event.target.value;
    },
    limitInput2(event) {
      var value = event.target.value;
      if (value == "0") {
        event.target.value = "";
      } else if (value >= 30) {
        event.target.value = 30;
      } else {
        event.target.value = value.replace(/[^\d]/g, "");
      }
      return event.target.value;
    },
    //批量下载
    batchUpload() {
      var dayNum = this.staValue;
      if (this.staValue === "") {
        dayNum = this.customValue;
        if (this.customValue >= 30) {
          dayNum = 30;
        }
        if (!dayNum && this.timeType == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType == 2 && !this.startTime) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType == 2 && !this.endTime) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      this.control1 = true;
    },
    //人群导出下载
    batchUpload1() {
      var dayNum = this.staValue1;
      if (this.staValue1 === "") {
        dayNum = this.customValue1;
        if (this.customValue1 >= 30) {
          dayNum = 30;
        }
        if (!dayNum && this.timeType1 == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType1 == 2 && !this.startTime1) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType1 == 2 && !this.endTime1) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      let arrA = {
        dayNum: dayNum,
        marketingId: this.$data.id,
        exportRemark: this.customValue2,
        startTime: this.startTime1,
        endTime: this.endTime1,
      };
      this.loading = true;
      mnode.exportCrow(arrA).then((res) => {
        if (res.code == 1) {
          this.staVisible1 = false;
          this.control2 = true;
          this.flags = 1;
        } else {
          this.$message.error(res.data);
        }
        this.loading = false;
      });
      this.loading = false;
    },
    //咚咚消息导出下载
    batchUpload2() {
      var dayNum = this.staValueOne;
      if (this.staValueOne === "") {
        dayNum = this.customValue3;
        if (this.customValue3 >= 30) {
          dayNum = 30;
        }
        if (!dayNum && this.timeType2 == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType2 == 2 && !this.startTime2) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType2 == 2 && !this.endTime2) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      this.control3 = true;
    },
    getphone1(val) {
      var dayNum = this.staValue;
      if (this.staValue === "") {
        dayNum = this.customValue;
        if (this.customValue >= 30) {
          dayNum = 30;
        }
        if (!dayNum && this.timeType == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType == 2 && !this.startTime) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType == 2 && !this.endTime) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      let param = {
        marketingId: this.$data.id,
        content: this.form.content,
        dayNum: dayNum,
        source: 3,
        exportRemark: val,
        startTime: this.startTime,
        endTime: this.endTime,
      };

      if (this.form.sendTimeStart) {
        param.sendTimeStart = this.form.sendTimeStart;
      }
      if (this.form.sendTimeEnd) {
        param.sendTimeEnd = this.form.sendTimeEnd;
      }
      let paramStr = "";
      for (var key in param) {
        let temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      // const res = getRecordList(paramStr);
      // this.loading = false;
      // if (res.data.message === "根据查询条件未查询到相关短信记录") {
      //   this.$message.error("当前活动没有短信批次");
      //   return;
      // }
      this.loading = true;
      exportMarketing(paramStr).then((res) => {
        if (res.code == 1) {
          this.staVisible = false;
          this.control1 = true;
        } else {
          this.$message.error(res.data);
        }
        this.loading = false;
      });
      // let elem = document.createElement("a");
      // elem.style.display = "none";
      // let url =
      //   "/jd-yusms/sms/marketing/effect/analyze/official/select/export?" +
      //   paramStr;
      // elem.href = url;
      // document.body.appendChild(elem);
      // elem.click();
      // document.body.removeChild(elem);
      // this.staVisible = false;
    },
    getphone3(val) {
      var dayNum = this.staValueOne;
      if (this.staValueOne === "") {
        dayNum = this.customValue3;
        if (this.customValue3 >= 30) {
          dayNum = 30;
        }
        if (!dayNum && this.timeType2 == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType2 == 2 && !this.startTime2) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType2 == 2 && !this.endTime2) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      let param = {
        marketingId: this.$data.id,
        content: this.form.content,
        dayNum: dayNum,
        source: 6,
        exportRemark: val,
        startTime: this.startTime2,
        endTime: this.endTime2,
      };

      if (this.form.sendTimeStart) {
        param.sendTimeStart = this.form.sendTimeStart;
      }
      if (this.form.sendTimeEnd) {
        param.sendTimeEnd = this.form.sendTimeEnd;
      }
      let paramStr = "";
      for (var key in param) {
        let temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      this.loading = true;
      exportMarketing(paramStr).then((res) => {
        if (res.code == 1) {
          this.staVisibleOne = false;
          this.control3 = true;
        } else {
          this.$message.error(res.data);
        }
        this.loading = false;
      });
    },
    testAllOne() {
      this.feld = true;
      mnode
        .getExecNodeAllResultCount({ marketingId: this.$data.id })
        .then((val) => {
          //正式
          this.allCount = val.data.allCount
          this.querycheck = {
            time: val.data.executionDate, //执行时间
            totalNumber: val.data.sumCount, //总触达人数
            totalmsg: val.data.msgCount, //总消耗短信
            send: val.data.sendIngNum, //已发送
            tnbeSent: val.data.waitNum, //待发送
            touchCount: val.data.touchCount, // 普通短信触达人数
            msgCount: val.data.msgCount, // 普通短信消耗短信数
            sendIngNum: val.data.sendIngNum, // 普通短信已发送数
            waitNum: val.data.waitNum, // 普通短信待发送人数
            mediaTouchCount: val.data.mediaTouchCount, // 富信短信触达人数
            mediaMsgCount: val.data.mediaMsgCount, // 富信短信消耗短信数
            mediaSendIngNum: val.data.mediaSendIngNum, // 富信短信已发送数
            mediaWaitNum: val.data.mediaWaitNum, // 富信短信待发送人数
            cardTouchCount: val.data.cardSmsTouchCount, // 卡片短信触达人数
            cardMsgCount: val.data.cardSmsMsgCount, // 卡片短信消耗短信数
            cardSendIngNum: val.data.cardSmsSendIngNum, // 卡片短信已发送数
            cardWaitNum: val.data.cardSmsWaitNum, // 卡片短信待发送人数
          };
        });
    },
    //Note展开，收起
    collapse() {
      this.openCollapse = !this.openCollapse;
    },
    // 获取活动节点最小等待时间
    getLimitTime() {
      var param = {
        marketingId: this.$data.id,
      };
      getMinWaitTime(param).then((res) => {
        if (res.code == "1" && res.data) {
          var timeStr = res.data;
          // 限制时间为最小等待时间的半个小时后
          var date = new Date(timeStr);
          date.setMinutes(date.getMinutes() - 40);
          this.maxLimitDate = this.$getNowDate(date);
          this.defaultTime =
            new Date(this.maxLimitDate.substring(0, 10)).getTime() -
            24 * 60 * 60 * 1000;
        } else if (res.code == "1") {
          console.log(1);
          this.pickerOptions = {
            disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7;
            },
          };
        }
      });
    },
    limitInput(event) {
      event.target.value = event.target.value.replace(/[^\d]/g, "");
    },
    //Note另存为模板
    saveAstemplateClick() {
      this.buriedPoint(9, "另存为模板", "", "");
      this.dialogTemplateFormVisible = true;
    },
    //Note京东批量设置等待节点
    batchSettings(command) {
      this.buriedPoint(9, "批量设置", "", "");
      let diagram = this.$refs.diag.diagram;
      var nodeOrLinkListBatch = diagram.selection;
      var nodeNumListBatch = [];
      nodeOrLinkListBatch.each((nodeOrLink, index) => {
        nodeNumListBatch.push(nodeOrLink.data);
      });
      var batchNum = [];
      //判断所选的节点是不是相同的
      function checkAdult(age) {
        if (age.length > 0) {
          return !age.some(function (value, index) {
            return value !== age[0];
          });
        } else {
          return true;
        }
      }
      // 判断有无选中节点
      if (!nodeNumListBatch.length) return;
      nodeNumListBatch.forEach((el, index) => {
        batchNum.push(el.category);
      });
      if (
        checkAdult(batchNum) == true &&
        nodeNumListBatch[0].category == "await" &&
        command == "await"
      ) {
        let model = this.model();
        this.batchsettingVisible = true;
        this.batchSure = nodeNumListBatch.length;
        this.nodeNumListBatchNum = nodeNumListBatch;
        console.log(nodeNumListBatch, "25698547");
        nodeNumListBatch.forEach((e) => {
          model.setDataProperty(
            model.findNodeDataForKey(e.nodeId),
            "isSaveContent",
            true
          );
        });
      } else if (
        checkAdult(batchNum) == true &&
        nodeNumListBatch[0].category == "msg" &&
        command == "msg"
      ) {
        nodeNumListBatch.forEach((el, index) => {
          batchNum.push(el.category);
        });
        let model = this.model();
        this.msgVisible = true;
        this.msgMore = nodeNumListBatch.length
          ? String(nodeNumListBatch.length)
          : "";
        this.nodeNumListBatchNumOne = nodeNumListBatch;
        nodeNumListBatch.forEach((e) => {
          model.setDataProperty(
            model.findNodeDataForKey(e.nodeId),
            "isSaveContent",
            true
          );
        });
      } else {
        if (command == "await") {
          this.$message.error("请选择多个等待节点，请勿选择其它节点");
        } else if (command == "msg") {
          this.$message.error("请选择多个短信节点，请勿选择其它节点");
        }
        return;
      }
    },
    //Note使用教程
    usingTutorials() {
      this.buriedPoint(9, "使用教程", "", "");
      window.open("https://www.yuque.com/yunduanxincrm/kb/ucmk4l", "_blank");
    },
    //Note跳转到页面
    iconHome() {
      window.sessionStorage.clear();
      sessionStorage.clear();
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/intelligent_market",
      });
      window.open(routeUrl.href, "_blank");
    },
    //Note获取下拉列表
    selint(e) {
      let obj = {
        activityName: "",
        current: 1,
        size: 10,
        webActivityStatus: "",
      };
      getIntelligentList(obj).then((res) => {
        if (res.code == "1") {
          this.$data.tableData = res.data.records;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //Note下拉事件
    changeValue2(e) {
      console.log("888888", e);
      sessionStorage.setItem("markId", e.id);
      sessionStorage.setItem("markNum", e.activityName);
      sessionStorage.setItem("statusNames", e.activityStatus);
      this.$data.statusNum = sessionStorage.getItem("statusNames")
        ? sessionStorage.getItem("statusNames")
        : this.$route.query.statusNum;
      if (e.activityStatus == 2) {
        this.testAllOne();
      } else {
        this.feld = false;
      }
      if (e.activityStatus == 4) {
        //已完成预执行的时候显示
        this.testAll();
      } else {
        this.smCount = 0;
      }
      this.$data.id = e.id;
      this.$data.actName = e.activityName;
      this.setinit();
    },
    //立即确定
    execSubmit() {
      let submit = true;
      let data = JSON.parse(JSON.stringify(this.$data.execform));
      console.log(data);
      data.id = 0 + this.$data.id;
      // if (data.executionType === 0) {
      if (!this.remindMobile) {
        submit = false;
        this.$message.error("请输入异常提醒手机号");
      } else {
        data["remindMobile"] = this.remindMobile;
      }
      // }
      if (this.executeTwo) {
        if (!data.timingExecutionTime) {
          submit = false;
          this.$message.error("请选择执行时间");
        }
      }
      if (this.executeOne) {
        if (data.cycleExecutionType === 0) {
          if (!data.cycleDay) {
            submit = false;
            this.$message.error("请输入日期间隔");
          }
          if (!new RegExp("^([1-9]|[1-9]\\d|100)$", "g").test(data.cycleDay)) {
            submit = false;
            this.$message.error("日期间隔天数请输入1-100之间的整数！");
          }
        } else if (data.cycleExecutionType === 1) {
          if (!data.cycleDayWeekly.length) {
            submit = false;
            this.$message.error("请选择执行星期");
          }
        } else if (data.cycleExecutionType === 2) {
          if (!data.cycleDayMonthly.length) {
            submit = false;
            this.$message.error("请选择执行日期");
          }
        }
        if (submit) {
          if (!data.datetime.length) {
            submit = false;
            this.$message.error("请选择执行范围");
          }
        }
      }
      if (submit) {
        data.cycleDayMonthly = data.cycleDayMonthly.join(",");
        data.cycleDayWeekly = data.cycleDayWeekly.join(",");
        data.cycleStartTime = data.datetime[0] || "";
        data.cycleEndTime = data.datetime[1] || "";
        delete data.datetime;
        if (this.execute) {
          data.executionType = 0;
        } else if (this.executeOne) {
          data.executionType = 2;
        } else {
          data.executionType = 1;
        }
        mnode
          .execacticity(data)
          .then((response) => {
            if (response.code === 1) {
              this.$message.success(response.message);
              this.executeOne = false;
              this.executeTwo = false;
              this.execute = false;
              this.excChange();
              this.smCount = 0;
            } else {
              this.$message.error(response.message);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
    },
    close() {
      this.batchsettingVisible = false;
    },
    backout() {
      //Note-------垂直排序方法
      const diagram = this.$refs.diag.diagram;
      diagram.startTransaction("aligning left");
      let minPosition = Infinity;
      diagram.selection.each((current) => {
        if (current instanceof go.Link) return;
        minPosition = Math.min(current.position.x, minPosition);
      });
      diagram.selection.each((current) => {
        if (current instanceof go.Link) return; // skips over go.Link
        current.move(new go.Point(minPosition, current.position.y));
      });
      diagram.commitTransaction("aligning left");
      //Note获取平移坐标，传给后端
      let nodeOrLinkList = diagram.selection;
      let nodeNumListTwo = [];
      let sumArray = [];
      nodeOrLinkList.each((nodeOrLink, index) => {
        nodeNumListTwo.push(nodeOrLink.data);
      });
      const session = JSON.parse(sessionStorage.getItem("batch"));
      session.forEach((v, index) => {
        if (session[index].coordinate) {
          let coordinate = nodeNumListTwo[index].coordinate.split(" ");
          sumArray.push(parseInt(coordinate[0]));
        }
      });
      sumArray.sort(function (a, b) {
        return a - b;
      });
      let min = sumArray[0];
      session.forEach((v, index) => {
        if (session[index].coordinate) {
          let coordinate = session[index].coordinate.split(" ");
          session[index].coordinate = `${min},${parseInt(coordinate[1])}`;
          var param = {
            nodeId: nodeNumListTwo[index].nodeId,
            coordinate: nodeNumListTwo[index].coordinate,
          };
          mnode.updateCoordinate(param);
        }
      });
    },
    recover() {
      //Note-------水平排序方法
      const diagram = this.$refs.diag.diagram;
      const firstSelection = diagram.selection.first();
      if (!firstSelection) return;
      diagram.startTransaction("aligning Center Y");
      const centerY =
        firstSelection.actualBounds.y + firstSelection.actualBounds.height / 2;
      diagram.selection.each((current) => {
        if (current instanceof this.$go.Link) return; // skips over go.Link
        current.move(
          new go.Point(
            current.actualBounds.x,
            centerY - current.actualBounds.height / 2
          )
        );
      });
      diagram.commitTransaction("aligning Center Y");
      //Note获取垂直坐标，传给后端
      let nodeOrLinkList = diagram.selection;
      let nodeNumListThree = [];
      let sumArray = [];
      nodeOrLinkList.each((nodeOrLink, index) => {
        nodeNumListThree.push(nodeOrLink.data);
      });
      //选择纵坐标
      const session = JSON.parse(sessionStorage.getItem("batch"));
      session.forEach((v, index) => {
        if (session[index].coordinate) {
          let coordinate = session[index].coordinate.split(" ");
          sumArray.push(parseInt(coordinate[1]));
        }
      });
      sumArray.sort(function (a, b) {
        return a - b;
      });
      let min = sumArray[0];
      session.forEach((v, index) => {
        if (session[index].coordinate) {
          let coordinate = session[index].coordinate.split(" ");
          session[index].coordinate = `${parseInt(coordinate[0])},${min}`;
          var param = {
            nodeId: nodeNumListThree[index].nodeId,
            coordinate: nodeNumListThree[index].coordinate,
          };
          mnode.updateCoordinate(param);
        }
      });
    },
    changeValue1(e) {
      if (e == "立即执行") {
        this.buriedPoint(9, "正式发送", "", "");
        console.log(this.statusNum, "65465465645");
        //判断是否有短信批次
        checkMarketingExecuted(this.$data.id).then((res) => {
          if (!res.data) {
            this.execute = true;
            this.executeOne = false;
            this.executeTwo = false;
          } else {
            this.$confirm(
              "该任务已经正式执行过，请前往短信记录中确保没有生成的批次再操作执行哦！（如果有生成的批次，请先取消后再执行，避免短信重复发送）",
              "提示",
              {
                confirmButtonText: "确定操作",
                cancelButtonText: "取消",
                type: "warning",
                iconClass: "el-icon-warning",
              }
            )
              .then(() => {
                this.execute = true;
                this.executeOne = false;
                this.executeTwo = false;
              })
              .catch(() => {
                this.$message.info("已取消删除");
              });
          }
        });
      }
      if (e == "周期执行") {
        this.buriedPoint(9, "正式发送", "", "");
        this.execute = false;
        this.executeOne = true;
        this.executeTwo = false;
      }
      if (e == "定时执行") {
        this.buriedPoint(9, "正式发送", "", "");
        //判断是否有短信批次
        checkMarketingExecuted(this.$data.id).then((res) => {
          if (!res.data) {
            this.execute = false;
            this.executeOne = false;
            this.executeTwo = true;
          } else {
            this.$confirm(
              "该任务已经正式执行过，请前往短信记录中确保没有生成的批次再操作执行哦！（如果有生成的批次，请先取消后再执行，避免短信重复发送）",
              "提示",
              {
                confirmButtonText: "确定操作",
                cancelButtonText: "取消",
                type: "warning",
                iconClass: "el-icon-warning",
              }
            )
              .then(() => {
                this.execute = false;
                this.executeOne = false;
                this.executeTwo = true;
              })
              .catch(() => {
                this.$message.info("已取消删除");
              });
          }
        });
      }
      // 默认配置手机号
      this.remindMobile = this.errorRemindMobile;
      this.execform = {
        id: 0,
        executionType: 0,
        timingExecutionTime: "",
        cycleExecutionType: 0,
        cycleDay: 0,
        cycleDayWeekly: [],
        cycleDayMonthly: [],
        cycleExecutionTime: "00:00:00",
        datetime: [],
        cycleStartTime: "",
        cycleEndTime: "",
      };
    },
    //Note智能营销优化
    editA() {
      this.modify = false;
      this.modifyOne = true;
      this.inputEdit = this.actName;
      this.inputEdit2 = this.actName;
      this.$nextTick(() => {
        this.$refs.inputRef && this.$refs.inputRef.focus();
      });
    },
    changeBlur() {
      console.log("1111111");
      this.modify = true;
      this.modifyOne = false;
      this.actName = this.inputEdit;
      this.$data.formName.smartMarketingId = this.$data.id;
      this.$data.formName.activityName = this.$data.actName;
      this.$data.formName.id = this.$data.id;
      sessionStorage.setItem("name", this.$data.formName.activityName);
      // this.actNameOne =  this.$data.formName.activityName
      updateIntelligent(this.$data.formName).then((response) => {
        if (response.code === 1) {
          this.$message.success("修改成功！");
          sessionStorage.removeItem("markNum");
          // this.$data.tableData[this.$data.changeIndex].activityName = this.$data.formName.activityName
          // this.$data.dialogFormVisible = false
          // this.$refs.formName.resetFields()
        } else {
          this.$message.error(response.message);
          this.actName = this.inputEdit2;
        }
      });
    },
    nodeView(e) {
      let diagram = this.$refs.diag.diagram;
      let node = e.diagram.selection.first();
      setTimeout(() => {
        diagram.scrollToRect(node.actualBounds);
      }, 100);
    },
    excChange() {
      var data = this.diagramData.nodeDataArray;
      this.$data.marketingDetail = 1;
      this.changeVIew(1);
      data.forEach((sitem) => {
        sitem.resultCount = "";
        sitem.executionStatus = 0;
        sitem.isSaveContent = 1;
      });
      this.updateDiagramFromData();
    },
    updateDiagramFromData() {
      this.$refs.diag.updateDiagramFromData();
    },
    extractionChanges(){
      let diagram = this.$refs.diag.diagram;
      //获取到选择多节点的数据
      var nodeOrLinkList = diagram.selection.toArray().map(node => node.data);;
      var nodeNumList = [];
      if(nodeOrLinkList){
        nodeNumList = [...nodeOrLinkList]
      }
      this.setinit(nodeNumList);
      // setTimeout(()=>{
      //   this.usingTutorials1();
      // },2000)
    },
    //操作了排重和抽取
    extractionChange() {
      let diagram = this.$refs.diag.diagram;
      //获取到选择多节点的数据
      var nodeOrLinkList = diagram.selection.toArray().map(node => node.data);;
      var nodeNumList = [];
      if(nodeOrLinkList){
        nodeNumList = [...nodeOrLinkList]
      }
      this.setinit(nodeNumList);
    },
    //刷新列表
    setinit(listNode) {
      //处理客户分群刷新滚动条变动问题提
      let mapLoc = sessionStorage.getItem("diagramP");
      mnode.getNodeList({ marketingId: this.$data.id }).then((res) => {
        if (res) {
          this.hasCardSms = false;
          this.hasMedialSms = false;
          this.hasSms = false;
          res.nodeDataArray.forEach((item) => {
            if (item.type == 15) {
              this.hasCardSms = true;
            }
            if (item.type == 13) {
              this.hasMedialSms = true;
            }
            if (item.type == 7) {
              this.hasSms = true;
            }
          });
          let diagramData = {
            nodeDataArray: res.nodeDataArray,
            linkDataArray: res.linkDataArray,
          };
          diagramData.nodeDataArray.forEach((a, v) => {
            if (a.executionStatus == 5) {
              this.foreError = 1;
            }
          });
          this.$data.diagramData = diagramData;
          //刷新后节点会闪一下问题处理，智能营销1.0
          const propertiesToHide = [
            "vipVisible",
            "excludeVisible",
            "extractionVisible",
            "uniqueVisible",
          ];
          setTimeout(() => {
            propertiesToHide.forEach((property) => {
              this[property] = false;
            });
          }, 100);
          this.$data.isReadOnly = res.marketingDetail !== 0;
          this.$data.isResets = res.marketingDetail === 2;
          this.$data.marketingDetail = res.marketingDetail;
          clearInterval(activityInterval);
          if (res.marketingDetail === 3) {
            this.changeVIew(0);
          }
          if (res.marketingDetail === 1) {
            this.changeVIew(1);
          }
          //处理客户分群刷新滚动条变动问题提
          this.$nextTick(() => {
            if (mapLoc) {
              let diagram = this.$refs.diag.diagram;
              let x = Number(JSON.parse(mapLoc).x);
              let y = Number(JSON.parse(mapLoc).y);
              diagram.initialPosition = new go.Point(x, y);
            }
            if (listNode && listNode.length > 0) {
              let diagramRef = this.$refs.diag.diagram;
              listNode.forEach(item => {
                diagramRef.select(diagramRef.findNodeForKey(item.key));
              })
            }
          });
        }
      });
    },
    changeVIew(type, value) {
      if (type) {
        this.$data.isExec = false; //正式发送
        if (this.execute) {
          this.statusNum = 1;
        } else {
          this.statusNum = 5;
        }
      } else {
        this.$data.isTest = false; //测试发送
        this.statusNum = 3;
      }
      var interval = function () {
        mnode
          .getExecNodeResultCount({
            marketingId: this.$data.id,
          })
          .then((res) => {
            if (res.code == 1) {
              let model = this.model();
              model.startTransaction();
              // nodeResultCountDetailList智能营销节点，统计人数信息
              res.data.nodeResultCountDetailList.forEach((item) => {
                if (item.status == 5) this.foreError = 1;
                model.setDataProperty(
                  model.findNodeDataForKey(item.nodeId),
                  "resultCount",
                  item.resultCount == 0
                    ? ""
                    : item.resultCount == -1
                    ? ""
                    : item.resultCount
                );
                model.setDataProperty(
                  model.findNodeDataForKey(item.nodeId),
                  "executionStatus",
                  item.status
                );
                //节点信息报错鼠标移动提示
                model.setDataProperty(
                  model.findNodeDataForKey(item.nodeId),
                  "errorDesc",
                  item.errorDesc == null ? "" : item.errorDesc
                );
              });
              model.commitTransaction("updateStatus");
              if (res.data.status) {
                var _that = this;
                clearInterval(activityInterval);
                _that.info("预执行活动成功！");
                mnode
                  .getExecNodeAllResultCount({ marketingId: this.$data.id })
                  .then((val) => {
                    // this.batchVisible = true;
                    this.allCount = val.data.allCount
                    this.batchItem.batchNum = val.data.batchNum;
                    this.batchItem.msgCount = val.data.msgCount;
                    this.batchItem.sumCount = val.data.sumCount;
                    this.batchItem.warning = val.data.warning;
                    this.smCount = val.data.sumCount;
                    this.smCountTwo = val.data.msgCount;
                    this.smCountOne = val.data.warning;
                    this.testSmsQuery = {
                      touchCount: val.data.touchCount, // 普通短信触达人数
                      msgCount: val.data.msgCount, // 普通短信消耗短信数
                      mediaTouchCount: val.data.mediaTouchCount, // 富信触达人数
                      mediaMsgCount: val.data.mediaMsgCount, // 富信消耗短信数
                      warning: val.data.warning, // 普通短信余额
                      mediaWarning: val.data.mediaWarning, // 富信余额
                      cardTouchCount: val.data.cardSmsTouchCount, // 卡片短信触达人数
                      cardMsgCount: val.data.cardSmsMsgCount, // 卡片短信消耗短信数
                      cardWarning: val.data.cardSmsWarning, // 富信余额
                    };

                    mnode.getStatus(this.$data.id).then((res) => {
                      this.statusNum = res.data.activityStatus;
                      if (!res.data.lastTestTime) {
                        this.checkedNum = 0;
                      } else {
                        this.checkedNum = 1;
                      }
                      sessionStorage.setItem("statusNames", this.statusNum);
                      if (this.statusNum == 2) {
                        this.feld = true;
                        this.smCount = 0;
                        this.testAllOne();
                      } else if (this.statusNum == 4) {
                        this.feld = false;
                      }
                    });
                    // if(this.smCount > 0) {
                    //   sessionStorage.setItem('statusNames',this.statusNum)
                    // }
                  });
                if (type) {
                  this.$data.marketingDetail = 2;
                  this.$data.isExec = true;
                  this.$data.isResets = true;
                } else {
                  // this.statusNum  = 4
                  this.$data.marketingDetail = 4;
                  this.$data.isTest = true;
                }
              }
            }
          });
      };
      activityInterval = setInterval(interval.bind(this), type ? 5000 : 2000);
    },
    //点击恢复编辑方法
    executes() {
      if (!this.$data.isResets) {
        mnode.redesignMarketing(this.$data.id).then((res) => {
          if (res.code === 1) {
            sessionStorage.setItem("statusNames", 0);
            this.statusNum = sessionStorage.getItem("statusNames");
            //Note恢复编辑之后隐藏
            this.smCount = 0;
            this.feld = false;
            this.$message.success(res.message);
            this.$data.isTest = true;
            this.$data.isExec = true;
            this.setinit();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.info("正式执行后不能恢复编辑！");
      }
    },
    reset() {
      this.buriedPoint(9, "恢复设计", "", "");
      //判断查询活动是否生成批次
      checkMarketingExecuted(this.$data.id).then((res) => {
        if (!res.data) {
          this.executes();
        } else {
          this.$confirm(
            "该任务已经正式执行过，请前往短信记录中确保没有生成的批次再操作执行哦！（如果有生成的批次，请先取消后再执行，避免短信重复发送）",
            "提示",
            {
              confirmButtonText: "确定操作",
              cancelButtonText: "取消",
              type: "warning",
              iconClass: "el-icon-warning",
            }
          )
            .then(() => {
              this.executes();
            })
            .catch(() => {
              this.$message.info("已取消删除");
            });
        }
      });
      this.getStatus();
    },
    //节点连线返回500的时候，自动删除
    LinkDrawn(e) {
      // console.log(12321312321321);
      let model = this.model();
      let diagram = this.$refs.diag.diagram;
      setTimeout(() => {
        mnode
          .updateNodeRel({
            marketingId: this.$data.id, //活动id
            parentId: this.currentLink.from,
            nodeId: this.currentLink.to,
          })
          .then((res) => {
            if (res.code == 1) {
            } else {
              diagram.model.removeLinkData(e.subject.data);
              diagram.model.startTransaction();
              this.$message.error(res.message);
            }
          })
          .catch((a) => {
            model.removeLinkData(e.subject.data);
          });
      }, 50);
    },
    //菜单拖拽
    dragstart(e, i) {
      //拖拽进来存的图标和名字，icon和index，name，其中dataTransfer是专门用来存储拖放的数据的
      e.dataTransfer.setData("text", JSON.stringify(i));
    },
    drop(e) {
      //计算被拖入图元的坐标
      if (!this.$data.isReadOnly) {
        let can = this.$refs.diag.$refs.diagram;
        let pixelratio = window.PIXELRATIO || 1;
        let bbox = can.getBoundingClientRect();
        let bbw = bbox.width;
        if (bbw === 0) bbw = 0.001;
        let bbh = bbox.height;
        if (bbh === 0) bbh = 0.001;
        let mx = e.clientX - bbox.left * (can.clientWidth / pixelratio / bbw);
        let my = e.clientY - bbox.top * (can.clientHeight / pixelratio / bbh);
        let point = this.$refs.diag.diagram.transformViewToDoc(
          new this.$go.Point(mx, my) //起点坐标
        );
        let item = JSON.parse(e.dataTransfer.getData("text"));
        let category = item.icon.split("__")[0];
        let data = {
          marketingId: this.$data.id, //后续需要放开
          type: item.index,
          name: item.name,
          text: item.name,
          category: category,
          coordinate: `${point.x.toFixed(2)},${point.y.toFixed(2)}`,
        };
        if (category == "order") {
          if (
            this.permissions &&
            this.permissions.indexOf("hide:show:order:node") != "-1"
          ) {
            this.isAdvanced = false;
          } else {
            this.isAdvanced = true;
            return;
          }
          // // 判断权限
          // if (
          //   !this.$decrypt.menuPermission(
          //     this.$store.state.route,
          //     "order_sent"
          //   ) &&
          //   !this.$decrypt.menuPermission(
          //     this.$store.state.route,
          //     "self_order_send"
          //   )
          // ) {
          //   this.isAdvanced = true;
          //   return;
          // }
        } else if (category == "presell") {
          //订单发送和预售订单权限处理
          if (
            this.permissions &&
            this.permissions.indexOf("hide:show:order:node") != "-1"
          ) {
            this.isAdvanced = false;
          } else {
            this.isAdvanced = true;
            return;
          }
          // if (
          //   !this.$decrypt.menuPermission(
          //     this.$store.state.route,
          //     "pop_presell_order_send"
          //   ) &&
          //   !this.$decrypt.menuPermission(
          //     this.$store.state.route,
          //     "self_presell_order_send"
          //   )
          // ) {
          //   this.isAdvanced = true;
          //   return;
          // }
        }
        mnode.addNode(data).then((res) => {
          if (res.code) {
            data.nodeId = data.key = res.data;
            data.isSaveContent = category === "analyze";
            data.coordinate = `${point.x.toFixed(2)} ${point.y.toFixed(2)}`;
            this.$data.nodeId = res.data;
            this.addNode(data);
            // if (typeof this.$data[category + 'Visible'] !== 'undefined') {
            //   this.$data[category + 'Visible'] = !this.$data[category + 'Visible']
            // } else {
            //   this.addNode({})
            // }
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.readOnly();
      }
      e.preventDefault();
      e.stopPropagation();
    },
    //添加节点的方法
    addNode(ndata, value) {
      console.log(ndata, "56565565656");
      let isOpen = this.useQuickForm.nodeConfig == 0 ? true : false;
      if (value != "noOpen") {
        if (ndata.name == "客户分群") {
          this.$data.vipVisible = isOpen;
        } else if (ndata.name == "订单筛选") {
          this.$data.orderVisible = isOpen;
        } else if (ndata.name == "预售订单") {
          this.$data.presellVisible = isOpen;
        }
      }
      //获取当前画布位置,处理客户分群节点刷新后画布滚动条偏上问题
      let diagram = this.$refs.diag.diagram;
      if (diagram) {
        let locMap = diagram.position;
        sessionStorage.setItem("diagramP", JSON.stringify(locMap));
      }
      let data = null;
      //获取gojs模型
      let model = this.model();
      data = JSON.parse(JSON.stringify(ndata));
      //所有模型更改都应该在事务模型中进行
      model.startTransaction();
      //添加节点数据，当您要将节点或者组添加到图中时，请使用新的数据对象调用此方法，这会将数据添加到
      // nodeDataArray并通知所有侦听器新的节点数据对象已插入到集合中。
      model.addNodeData(data);
      //提交当前事务的更改
      model.commitTransaction(`added Node`);
      // 选中当前项目
      // let diagram = this.$refs.diag.diagram;
      // 选择 使给定对象成为唯一选定的对象，此方法会引发ChangingSelection和ChangedSelection图事假，在diagram中有。
      // findNodeForData查询与模型的节点数据对象相对应的节点或者组，节点数量发生变化改变
      diagram.select(diagram.findNodeForData(data));
    },
    //测试执行
    testMSG() {
      //点击测试执行的时候，正式执行为置灰
      this.checkedNum = 0;
      this.buriedPoint(9, "测试执行", "", "");
      mnode
        .getNodeList({
          marketingId: this.$data.id,
        })
        .then((res) => {
          res.nodeDataArray.forEach((e) => {
            if (e.isSaveContent == 0 || e.isSaveContent == false) {
              this.flag = false;
              let diagram = this.$refs.diag.diagram;
              let model = this.model();
              let node = diagram.findNodeForKey(e.nodeId);
              node.isSelected = true;
              return;
            } else {
              this.flag = true;
            }
          });
        });
      //温馨提示
      this.foreError = 0;
      if (this.$data.marketingDetail == 2) {
        this.$message.error("当前活动已经结束！");
        return;
      }
      if (this.$data.marketingDetail == 1) {
        this.$message.error("当前活动正式执行中！");
        return;
      }
      if (this.$data.isTest && this.$data.isExec) {
        mnode.testIntelligentMarketing(this.$data.id).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.message);
            this.isReadOnly = true;
            this.$data.marketingDetail = 3;
            this.changeVIew(0);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.info("执行中，请稍后再试！");
      }
    },
    //正式发送
    exec() {
      if (this.$data.marketingDetail === 2) {
        this.$message.error("当前活动已经结束！");
        return;
      }
      if (this.$data.marketingDetail === 1) {
        this.$message.error("当前活动正式执行中！");
        return;
      }
      if (
        this.$data.marketingDetail === 4 &&
        this.$data.isTest &&
        this.$data.isExec
      ) {
        this.execVisible = true;
      } else {
        if (!this.$data.isExec) {
          this.info("执行中，请稍后再试！");
        } else {
          this.info("请先执行测试发送！");
        }
      }
    },

    toggleFull() {
      //判断当前浏览器是否可全屏
      if (!screenfull.isEnabled) {
        this.$message({
          type: "warning",
          message: "当前不可全屏",
        });
        return false;
      }
      screenfull.toggle();
    },

    //预览小图
    preview() {},
    //访问GoJS图的GoJS模型
    model() {
      return this.$refs.diag.model();
    },
    //数据发生变化
    modelChanged(e) {
      //isTransactionFinished可以判断事件是否结束
      if (e.isTransactionFinished) {
        //e.oldValue === "Move"拖动节点放开时的数据改变
        if (e.oldValue === "Move" && this.edit) {
          //获取拖动节点的坐标
          let diagram = this.$refs.diag.diagram;
          var nodeOrLinkList = diagram.selection;
          var nodeNumList = [];
          nodeOrLinkList.each((nodeOrLink, index) => {
            nodeNumList.push(nodeOrLink.data);
          });
          if (nodeNumList.length > 1) {
            // 批量移动
            var nodeNumListPosition = [];
            var nodes = [];
            nodeNumList.forEach((v, index) => {
              if (nodeNumList[index].nodeId) {
                let coordinate = nodeNumList[index].coordinate.split(" ");
                nodeNumList[index].coordinate = `${parseInt(
                  coordinate[0]
                )},${parseInt(coordinate[1])}`;
                if (
                  nodeNumList[index].smartMarketingNodeId ||
                  nodeNumList[index].coordinate
                ) {
                  nodeNumListPosition.push(nodeNumList[index].coordinate);
                  nodes.push(nodeNumList[index].nodeId);
                }

                // var param = {
                //   nodeId: nodeNumList[index].nodeId,
                //   coordinate: nodeNumList[index].coordinate,
                // };
                // mnode.updateCoordinate(param);
              }
            });
            mnode
              .updateCoordinateBatch({
                intelligentMarketingNodeIds: nodes,
                coordinates: nodeNumListPosition,
              })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.error(res.message);
                }
              });
          } else {
            // 单独一个的移动
            let coordinate = this.currentNode.data.coordinate;
            coordinate = coordinate.split(" ");
            coordinate[0] = Number(coordinate[0]).toFixed(0); //获取x轴坐标
            coordinate[1] = Number(coordinate[1]).toFixed(0); //获取y轴坐标
            mnode
              .updateCoordinate({
                nodeId: this.currentNode.data.nodeId,
                coordinate: coordinate.join(","),
              })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.error(res.message);
                }
              });
          }
          console.log("length:", nodeNumList.length);
        }
        if (e.oldValue === "Paste") {
          this.SelectionCopied();
        }
        //节点连线调取接口
        if (e.oldValue === "Linking" && this.edit) {
          setTimeout(() => {}, 50);
        }
      }
    },
    //选择数据发生变化
    changedSelection(e) {
      let diagram = this.$refs.diag.diagram;
      sessionStorage.setItem("x", diagram.position.x);
      sessionStorage.setItem("y", diagram.position.y);
      //获取当前画布位置,处理客户分群节点刷新后画布滚动条偏上问题
      if (diagram) {
        let locMap = diagram.position;
        sessionStorage.setItem("diagramP", JSON.stringify(locMap));
      }
      console.log("000");
      //获取获得焦点的第一个元素，可为节点或者线。
      let node = e.diagram.selection.first();
      if (node instanceof this.$go.Node) {
        this.currentNode = node;
      } else {
        this.currentNode = null;
      }
      if (node instanceof this.$go.Link) {
        this.currentLink = JSON.parse(JSON.stringify(node.data));
        // this.numSure = this.currentLink.from;
      } else {
        this.currentLink = null;
      }
      //Note选择数据
      let nodeNumListBatch = [];
      let nodeOne = e.diagram.selection;
      nodeOne.each((nodeOrLink, index) => {
        nodeNumListBatch.push(nodeOrLink.data);
      });
      sessionStorage.setItem("batch", JSON.stringify(nodeNumListBatch));
    },
    //双击点击事件
    objectDoubleClicked(e) {
      console.log("554545445");
      let diagram = this.$refs.diag.diagram;
      sessionStorage.setItem("x", diagram.position.x);
      sessionStorage.setItem("y", diagram.position.y);
      //获取当前画布位置,处理客户分群节点刷新后画布滚动条偏上问题
      if (diagram) {
        let locMap = diagram.position;
        sessionStorage.setItem("diagramP", JSON.stringify(locMap));
      }
      // console.log("双击",this.currentNode.data,this.diagramData.linkDataArray);
      //this.currentNode.data是节点的具体信息
      let node = this.currentNode;
      console.log(node, "369852147", this.edit);
      if (node instanceof this.$go.Node && this.edit) {
        console.log("555555555555");
        let category = node.data.category;
        //判断是否是目标人群，就是抽取和排重节点生成，只能在上一节点进行编辑
        if (category === "targetGroups") {
          this.info("请在上一级节点进行编辑");
          return;
        }
        //排重(unique)和排除(exclude)的节点，至少要链接两个人群数据源
        if (
          (category == "unique" || category == "exclude") &&
          node.findNodesInto().count < 2
        ) {
          this.$message.error("请至少链入两个人群数据源");
          return;
        }
        //短信分析的节点(analyze),必须要再短信发送后才可以查看营销效果
        if (category == "analyze") {
          let params = this.$data.marketingDetail;
          sessionStorage.setItem("analyzestatus", params);
          //需要根据节点的状态返回来做确定，未打勾说明未开始营销
          // if (
          //   this.$data.marketingDetail === 0 ||
          //   this.$data.marketingDetail === 4
          // ) {
          //   this.$message.error("您还未开始营销，请在短信发送后可看营销效果");
          //   return;
          // }
        }
        //人群分析
        if (category == "customer") {
          this.buriedPoint(2, "人群分析", "客户营销", "智能营销");
          console.log(e.data.errorDesc, "99999");
          if (
            e.data.executionStatus == 5 &&
            e.data.errorDesc == "在执行过程中，您的人群库已超出数量限制"
          ) {
            this.customerBlock = true;
          } else {
            this.customerBlock = false;
          }
          //判断状态是设计中和预执行完成
          if (
            this.$data.marketingDetail === 0 ||
            this.$data.marketingDetail === 4
          ) {
            this.$data.nodeId = node.data.nodeId;
            this.$data.newNodeName = node.data.name;
            this.$data.customerVisible2 = true;
            this.analyzeNodeDTO = {
              type: "1",
            };
            mnode
              .getNode({
                nodeId: this.nodeId,
              })
              .then((res) => {
                this.analyzeNodeDTO = res.data;
              });
            return;
          }
          //正式执行后的状态是2是查询分析
          if (this.$data.executionType == 2) {
            this.marketStatus = 5; //给个标识传到人群那边去是周期执行
          } else {
            this.marketStatus = 6; //给个标识传到人群那边去，不是周期执行
          }
        }
        console.log("666666666666");
        //end
        //在同一个智能营销中smartMarketingNodeId就是节点标识
        this.$data.nodeId = node.data.nodeId;
        this.$data.newNodeName = node.data.name;
        if (category == "msg") {
          this.msgMore = "";
          this.nodeNumListBatchNumOne = [];
        }
        this.$data[category + "Visible"] = !this.$data[category + "Visible"];
        console.log("965284", this.$data[category + "Visible"]);
      }
    },
    //删除节点
    objectDelete(e) {
      if (this.edit && !this.$data.isReset) {
        let diagram = this.$refs.diag.diagram;
        //获取到选择多节点的数据
        var nodeOrLinkList = diagram.selection;
        var nodeNumList = [];
        nodeOrLinkList.each((nodeOrLink, index) => {
          nodeNumList.push(nodeOrLink.data);
        });
        if (nodeNumList.length > 1) {
          // 批量删除
          var nodeIds = [];
          var lineIds = [];
          nodeNumList.forEach((node, index) => {
            console.log("v=", node);
            if (nodeNumList[index].nodeId) {
              nodeIds.push(nodeNumList[index].nodeId);
            }
            if (nodeNumList[index].ids) {
              lineIds.push(nodeNumList[index].ids);
            }
          });
          var param = {
            nodeIds,
            lineIds,
          };
          mnode.delBatchNode(param).then((res) => {
            if (res.code === 1) {
              //链接排重删除，刷新列表
              if (res.data == true) {
                this.setinit();
              }
            } else {
              this.$message.error(res.data);
            }
          });
          console.log("nodeIds:", nodeIds);
        } else {
          let node = e.diagram.selection.first();
          // let diagram = this.$refs.diag.diagram;
          // var nodeOrLinkDelectList = diagram.selection;
          // var nodeNumDelectList = [];
          // var targetGroupsLength = 0;
          // nodeOrLinkDelectList.each((v, index) => {
          //   nodeNumDelectList.push(v.data);
          // });
          if (node instanceof this.$go.Node) {
            let noderel = [];
            //如果是抽取和排重的节点，生成的目标客户的节点都要移除
            if (
              node.data.category == "extraction" ||
              node.data.category == "unique"
            ) {
              //获取模型数据
              let model = this.model();
              //获取model在事务中执行
              model.startTransaction();
              //node.findNodesOutOf()查找节点的下一级节点
              //node.findNodesinto()查找节点的上一级节点
              //因为排重和抽取有多个目标客户，所有要查找他的下一个节点来移除
              node.findNodesOutOf().each((item) => {
                model.removeNodeData(item.data);
              });
              model.commitTransaction("updateStatus");
            }
            mnode
              .delNode({
                nodeId: node.data.nodeId,
              })
              .then((res) => {
                if (res.code === 1) {
                  // this.setinit();
                } else {
                  this.$message.error(res.data);
                  // this.setinit();
                }
              });
          }
          //Link线from和to
          if (node instanceof this.$go.Link) {
            mnode
              .delNodeRel({
                marketingId: this.$data.id,
                parentId: node.data.from,
                nodeId: node.data.to,
              })
              .then((res) => {
                if (res.code === 1) {
                  // this.setinit();
                } else {
                  this.$message.error(res.message);
                  this.setinit();
                }
              });
          }
          // if (nodeNumDelectList.length > 1) {
          //   nodeNumDelectList.forEach((v, index) => {
          //     if (v.category == "targetGroups") {
          //       targetGroupsLength++;
          //     } else {
          //       var obj = {};
          //       if(nodeNumDelectList[index].nodeId){
          //         obj.nodeId=nodeNumDelectList[index].nodeId
          //       }else{
          //         return true
          //       }
          //       let noderel = [];
          //       //如果是抽取和排重的节点，生成的目标客户的节点都要移除
          //       // if (
          //       //   nodeNumDelectList[index].category == "extraction" ||
          //       //   nodeNumDelectList[index].category == "unique"
          //       // ) {
          //       //   //获取模型数据
          //       //   let model = this.model();
          //       //   //获取model在事务中执行
          //       //   model.startTransaction();
          //       //   //node.findNodesOutOf()查找节点的下一级节点
          //       //   //node.findNodesinto()查找节点的上一级节点
          //       //   //因为排重和抽取有多个目标客户，所有要查找他的下一个节点来移除
          //       //   node.findNodesOutOf().each((item) => {
          //       //     model.removeNodeData(item.data);
          //       //   });
          //       //   model.commitTransaction("updateStatus");
          //       // }
          //       setTimeout(()=>{
          //         mnode.delNode(obj).then((res) => {
          //         if (res.code === 1) {
          //         } else {
          //           this.$message.error(res.data);
          //           this.setinit();
          //         }
          //       });
          //       },500)
          //     }
          //   });
          //   (targetGroupsLength == nodeNumDelectList.length) && (this.$message.error("目标人群不能删除"))
          //   setTimeout(()=>{this.setinit();},3000)
          // } else {
          //   if (node instanceof this.$go.Node) {
          //     let noderel = [];
          //     //如果是抽取和排重的节点，生成的目标客户的节点都要移除
          //     if (
          //       node.data.category == "extraction" ||
          //       node.data.category == "unique"
          //     ) {
          //       //获取模型数据
          //       let model = this.model();
          //       //获取model在事务中执行
          //       model.startTransaction();
          //       //node.findNodesOutOf()查找节点的下一级节点
          //       //node.findNodesinto()查找节点的上一级节点
          //       //因为排重和抽取有多个目标客户，所有要查找他的下一个节点来移除
          //       node.findNodesOutOf().each((item) => {
          //         model.removeNodeData(item.data);
          //       });
          //       model.commitTransaction("updateStatus");
          //     }
          //     mnode
          //       .delNode({
          //         nodeId: node.data.nodeId,
          //       })
          //       .then((res) => {
          //         if (res.code === 1) {
          //         } else {
          //           this.$message.error(res.data);
          //           this.setinit();
          //         }
          //       });
          //   }
          //   //Link线from和to
          //   if (node instanceof this.$go.Link) {
          //     mnode
          //       .delNodeRel({
          //         marketingId: this.$data.id,
          //         parentId: node.data.from,
          //         nodeId: node.data.to,
          //       })
          //       .then((res) => {
          //         if (res.code === 1) {
          //         } else {
          //           this.$message.error(res.message);
          //           this.setinit();
          //         }
          //       });
          //   }
          // }
        }
      }
    },
    readOnly() {
      this.info("恢复编辑可激活活动设计状态！");
    },
    info(message) {
      this.$notify.info({
        title: "消息",
        message: message,
      });
    },
    controllerClick(item) {
      if (item.name == "使用帮助") {
        window.open("https://www.yuque.com/yunduanxincrm/kb/ucmk4l", "_blank");
      }
      let type = item.icon;
      if (type == "reset" && this.editStatus == "1") {
        this.$message.info("活动状态为执行中不可恢复编辑");
        return;
      }
      this[type]();
    },
    //放大
    zoomOut() {
      let diagram = this.$refs.diag.diagram;
      if (diagram.commandHandler.canIncreaseZoom()) {
        diagram.commandHandler.increaseZoom();
      } else {
        this.$message.error("已经是最大了！");
      }
    },
    //缩小
    zoomIn() {
      let diagram = this.$refs.diag.diagram;
      if (diagram.commandHandler.canDecreaseZoom()) {
        diagram.commandHandler.decreaseZoom();
      } else {
        this.$message.error("已经是最小了！");
      }
    },
    //预览小图
    preview() {
      this.$data.isOverview = !this.$data.isOverview;
      if (!this.$data.isov) {
        this.$data.isov = true;
        let diagram = this.$refs.diag.diagram;
        diagram.commandHandler.increaseZoom();
      }
    },
    //复制
    copy() {
      if (this.$data.isReadOnly) {
        this.readOnly();
        return;
      }
      //别删除，多个节点复制逻辑
      let diagram = this.$refs.diag.diagram;
      //获取到选择多节点的数据
      var nodeOrLinkList = diagram.selection;
      var nodeNumList = [];
      nodeOrLinkList.each((nodeOrLink, index) => {
        nodeNumList.push(nodeOrLink.data);
      });

      if (nodeNumList.length > 1) {
        this.$message.error("请框选单个节点复制！");
        return;
      } else {
        if (diagram.selection.first()) {
          var node = diagram.selection.first().data;
        } else {
          this.$message.error("请选择要复制的节点！");
          return;
        }
      }

      if (nodeNumList.length > 1) {
        // 选中复制多个

        var nodeIds = [];
        nodeNumList.forEach((v, index) => {
          console.log("v=", v);
          // let obj = {
          //   smartMarketingId: this.$data.id,
          //   smartMarketingNodeId: nodeNumList[index].smartMarketingNodeId,
          //   coordinate: nodeNumList[index].coordinate,
          // };
          if (nodeNumList[index].nodeId) {
            nodeIds.push(nodeNumList[index].nodeId);
          }
        });
        var param = {
          nodeIds,
          offsetAbscissa: 200, // 横坐标偏移量
          offsetOrdinate: 200, // 纵坐标偏移量
          coordinateList: [],
        };
        mnode.copyBatchNode(param).then((res) => {
          if (res.code === 1) {
            var list = res.data;
            list.map((item) => {
              (item.smartMarketingNodeId = item.id),
                (item.smartMarketingId = item.marketingId);
            });
            this.setinit();
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      } else {
        diagram.commandHandler.copySelection();
        let node = diagram.selection.first().data;
        var nodeObj = diagram.selection.first();
        //不等于目标客户
        if (node.category !== "targetGroups") {
          node.smartMarketingId = this.$data.id;
          //获取节点的坐标数据
          // let coordinate = node.coordinate.split(" ");
          // node.coordinate = `${parseInt(coordinate[0]) + 50},${
          //   parseInt(coordinate[1]) - 50
          // }`;
          node.coordinate = `${parseInt(nodeObj.location.x) + 200},${
            parseInt(nodeObj.location.y) - 200
          }`;
          //如果是目标客户，营销分析等，他里边有条件就要用copy的接口，条件重新复制一份，后端那边处理
          mnode.copyNode(node.nodeId, node.coordinate).then((res) => {
            if (res.code === 1) {
              let data = JSON.parse(JSON.stringify(node));
              data.nodeId = data.key = res.data;

              if (data.category == "analyze") {
                // 跟随原节点，不做处理
              } else {
                data.isSaveContent = false;
              }
              this.$data.nodeId = res.data;
              delete data.__gohashid;
              data.coordinate = `${parseInt(nodeObj.location.x) + 200} ${
                parseInt(nodeObj.location.y) - 200
              }`;
              this.addNode(data, "noOpen");
            }
          });
        } else {
          this.$message.error("目标人群节点不能复制！");
        }
      }
      //Note---旧单节点复制代码
      // if (!diagram.commandHandler.canCopySelection()) {
      //     diagram.commandHandler.copySelection();
      //     let node = diagram.selection.first().data;
      //     //不等于目标客户
      //     if (node.category !== "targetGroups") {
      //       node.smartMarketingId = this.$data.id;
      //       //获取节点的坐标数据
      //       let coordinate = node.coordinate.split(" ");
      //       node.coordinate = `${parseInt(coordinate[0]) + 50},${parseInt(
      //         coordinate[1]
      //       ) - 50}`;
      //       //如果是目标客户，营销分析等，他里边有条件就要用copy的接口，条件重新复制一份，后端那边处理
      //       mnode.copyNode(node.nodeId,node.coordinate).then((res) => {
      //         if (res.code === 1) {
      //           // debugger
      //           let data = JSON.parse(JSON.stringify(node));
      //           data.nodeId = data.key = res.data;
      //           data.isSaveContent = false;
      //           this.$data.nodeId = res.data;
      //           delete data.__gohashid;
      //           // this.addNode(data);
      //         }
      //       });
      //     } else {
      //       this.$message.error("目标人群节点不能复制！");
      //     }
      //   } else {
      //     this.$message.error("请选择要复制的节点！");
      //   }
      // if (!diagram.commandHandler.canCopySelection()) {
      //   diagram.commandHandler.copySelection();
      //   nodeNumList.forEach((v, index) => {
      //     if (nodeNumList[index].category !== "targetGroups") {
      //       console.log("v", v);
      //       nodeNumList[index].smartMarketingId = this.$data.id;
      //       let coordinate = nodeNumList[index].coordinate.split(" ");
      //       nodeNumList[index].coordinate = `${parseInt(coordinate[0]) + 50},${parseInt(coordinate[1]) - 50}`;
      //       if (
      //         nodeNumList[index].name == "订单筛选" ||
      //         nodeNumList[index].name == "会员筛选" ||
      //         nodeNumList[index].name == "指定号码" ||
      //         nodeNumList[index].name == "高级分组" ||
      //         nodeNumList[index].name == "短信" ||
      //         nodeNumList[index].name == "等待" ||
      //         nodeNumList[index].type == "1" ||
      //         nodeNumList[index].type == "0" ||
      //         nodeNumList[index].type == "2" ||
      //         nodeNumList[index].type == "13" ||
      //         nodeNumList[index].type == "9" ||
      //         nodeNumList[index].type == "3"
      //       ) {
      //         let obj = {
      //           smartMarketingId: nodeNumList[index].smartMarketingId,
      //           smartMarketingNodeId: nodeNumList[index].nodeId,
      //           coordinate: nodeNumList[index].coordinate,
      //         };
      //         console.log("copyNode:", obj);
      //         mnode.copyNode(obj.smartMarketingNodeId, obj.coordinate).then((res) => {
      //           if (res.code === 1) {
      //             let data = JSON.parse(JSON.stringify(nodeNumList[index]));
      //             data.smartMarketingNodeId = data.key = res.data;
      //             // data.isSaveContent = data.category === 'msg'
      //             data.isSaveContent = false;
      //             this.$data.nodeId = res.data;
      //             data.nodeId = res.data;
      //             delete data.__gohashid;
      //             this.addNode(data);
      //           }
      //         });
      //       }
      //     } else {
      //       mnode.addNode(node).then((res) => {
      //         if (res.code === 1) {
      //           let data = JSON.parse(JSON.stringify(nodeNumList[index]));
      //           data.smartMarketingNodeId = data.key = res.data;
      //           //   data.isSaveContent = data.category === "msg";
      //           this.$data.nodeId = res.data;
      //           delete data.__gohashid;
      //           this.addNode(data);
      //         }
      //       });
      //     }
      //   });
      // } else {
      //   this.$message.error("目标人群节点不能复制！");
      // }
    },
    //另存为
    saveAs() {
      this.$data.dialogTemplateFormVisible =
        !this.$data.dialogTemplateFormVisible;
    },
    //另存为确定
    async saveAsTemplate() {
      //Note-------保存截图，自定义图片
      const diagram = this.$refs.diag.diagram;
      var img = diagram.makeImage({
        //  size: new go.Size(800,800), //生成图片大小
        scale: 1, //缩放比例
        background: "rgba(255,255,255)", //背景颜色
        //  type: "image/jpeg", //生成图片类型
        //  details: 0.9 //生成图片清晰度 （只在jpg格式下有效，取值范围0-1）
      });
      var url = img.src;
      //Notebase64转文件流
      const base64toFile = (dataurl, filename = "file") => {
        let arr = dataurl.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let suffix = mime.split("/")[1];
        let bstr = window.atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime,
        });
      };
      let formdata = new FormData();
      formdata.append("file", base64toFile(url));
      await uploadpic(formdata).then((res) => {
        // 获取图片真实url
        if (res.code === 1) {
          // this.$refs.upload.clearFiles();
          this.$data.formTemplate.picUrl = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
      this.$refs.formTemplate.validate((valid) => {
        if (valid) {
          this.$data.formTemplate.intelligentMarketingId = this.$data.id;
          mnode.addTemplate(this.$data.formTemplate).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.message);
              this.$data.dialogTemplateFormVisible = false;
              this.$data.formTemplate.name = "";
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改名称
    changedName(data) {
      const diagram = this.$refs.diag.diagram;
      // diagram.clearSelection(); //升级--去除选中框
      //findNodeDataForKey通过节点key获取节点，知道节点key，拿到这个节点的详细信息
      let model = this.model();
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "errorDesc",
        ""
      ); //升级--去除选中框
      //所有方法都要在事务中进行
      model.startTransaction();
      //首先是拿到这个对象的属性进行修改，如果没有则新增这个属性
      /*****
       * setDataProperty(data,propname,val)
       * data:nodeData或者linkData
       * propname:属性名
       * val:修改的值
       */
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "name",
        data.name
      );
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "text",
        data.name
      );
      model.setDataProperty(
        model.findNodeDataForKey(data.nodeId),
        "isSaveContent",
        true
      );
      //短信-批量设置名称设置完改变
      if (data.nodeIdList && data.nodeIdList.length) {
        data.nodeIdList.forEach((res) => {
          model.setDataProperty(
            model.findNodeDataForKey(res),
            "isSaveContent",
            true
          );
        });
      }
      //提交当前事务的修改
      model.commitTransaction("updateName");
      // 批量设置节点更新
      if (this.showNodeSetting) {
        this.$refs.nodeSettingRef.getList();
      }
    },
    //销毁前清理定时器
    beforeDestroy() {
      sessionStorage.clear();
      window.sessionStorage.clear();
      sessionStorage.removeItem("markNum");
      activityInterval && clearInterval(activityInterval);
    },
    //离开页面清除
    beforeRouteLeave(to, from, next) {
      sessionStorage.removeItem("markNum");
      window.sessionStorage.clear();
      sessionStorage.clear();
      sessionStorage.clear();
      if (this.Timer) {
        clearInterval(this.Timer);
        sessionStorage.clear();
      }
      next();
    },
    toDingGou() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch"
      );
    },
    // 短信节点复制提示
    showSmsTip() {
      this.$message.success(
        "复制成功！如短信内容含短链请重新生成，避免影响短链数据统计。"
      );
    },
    // 富信、卡片复制提示
    showRichTip() {
      this.$message.success(
        "复制成功！因官方规则限制，请重新选择富信/卡片短信模板，否则发送失败。"
      );
    },
    showCopyTip() {
      this.$message.success(
        "复制成功！请注意：①如短信内容含短链请重新生成，避免影响短链数据统计；②如含富信或卡片短信节点，请重新选择模板，否则发送失败。"
      );
    },
    setingMore(command) {
      if (command == "edit") {
        this.showNodeSetting = true;
      } else {
        this.batchSettings(command);
      }
    },
    // 打开对应节点的弹窗
    showNodeDialog(row) {
      this.nodeId = row.nodeId;
      let category;
      if (row.smsType == 0) {
        category = "msg";
      } else if (row.smsType == 1) {
        category = "medium";
      } else if (row.smsType == 2) {
        category = "card";
      }
      this.$data[category + "Visible"] = true;
    },
  },
};
</script>
<style lang="less">
@import "./less/icons.less";

.sizeIcon {
  width: 20px;
}

.batchdiv {
  padding: 10px 20px;
}
.bgimg {
  // background-size: 14px 14px;
  color: red;
  margin-left: 17px;
  background: url("../../assets/images/new_icon_waring.png") no-repeat left
    center;
}
//Note----新
.testClass {
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
  //  width:60%;
  width: 100%;
  padding: 10px;
  line-height: 25px;
  padding-left: 40px !important;
  position: absolute;
  z-index: 1111;
  bottom: 40px;
  left: 0;
  background: #fff;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 10px;
  overflow: hidden;
  transition: all 0.2s;
  max-width: 60px;
  min-height: 130px;
  max-height: 166px;
  .class {
    position: absolute;
    width: 60px;
    height: 100%;
    background: #ffff;
    right: 0;
    top: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
}
.testClassShow {
  max-width: 100%;
}
.intelligent-page {
  padding: 0;
  height: calc(100vh - 60px);
  .right-box-shodow {
    box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.05);
    width: 248px !important;
    user-select: none;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #dadada #f1f1f1;
  }
  .el-collapse-item__header {
    text-align: left;
  }
  .el-collapse-item__arrow {
    margin-right: 0px;
  }
  .el-collapse-item__content {
    padding-bottom: 16px;
    ul {
      padding-left: 0;
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
    }
    li {
      list-style: none;
      display: flex;
      align-items: center;
      width: 50%;
      margin-top: 15px;
      background: transparent;
      cursor: move;
      padding: 4px;
      &:hover {
        background-color: #f2f4f9;
        border-radius: 2px;
      }
      .collapse-name {
        white-space: nowrap;
        font-size: 12px;
      }
    }
    li:nth-child(-n + 2) {
      margin-top: 0;
    }
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
    padding-top: 7px;
  }
  .el-collapse-item {
    margin-top: 14px;
  }
  .el-collapse-item__header {
    border-bottom: none;
    height: auto;
    line-height: normal;
    padding-bottom: 4px;
    margin-bottom: 30px;
    border-bottom: 1px solid #ebeef5;
    color: #000;
  }
  .el-collapse-item__wrap {
    border-bottom: none;
  }
}
.operate-tips {
  float: right;
  color: #999999;
  font-size: 14px;
  margin-right: 24px;
  margin-top: 11px;
}
.padding-0 {
  padding: 0;
}
.padding-20 {
  padding-left: 16px;
  padding-right: 12px;
}
.tools-bar {
  display: flex;
  padding: 9px 16px 18px 0px;
  position: relative;
  margin-top: 9px;
  border-bottom: 1px solid #f3f3f3;
  .tools-controller {
    display: flex;
    align-items: center;
    flex: 1;
    margin-left: -75px;
  }
  .tools-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  span {
    font-size: 12px;
  }
}
.top-wrap {
  span {
    font-size: 12px;
  }
}
.canvas-box {
  margin-top: 10px;
  overflow: hidden;
  height: calc(100% - 130px);
  width: 100%;
}
canvas:focus {
  box-shadow: none;
  outline: none;
}
.nameTips {
  position: absolute;
  right: 15px;
  top: 0;
}
// .selectBox {
//   width: 100%;
//   display: flex;
//   position: relative;
// }
.switchover {
  position: absolute;
  right: 20px;
  top: -25px;
}
.lineBox {
  display: flex;
  align-items: center;
  margin-top: 10px;
  min-height: 32px;
  & .el-radio + .el-radio {
    margin-left: 3px;
  }
  & .el-badge__content.is-fixed {
    top: -7px;
  }
  & .el-checkbox-group .el-checkbox {
    margin-left: 10px;
  }
  & .el-checkbox-group .el-checkbox + .el-checkbox {
    margin-left: 10px;
  }
}
.lineBox:first-child {
  margin: 0;
}
.uploadTable {
  width: 100%;
  & td,
  & th {
    padding: 0 0;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}

.btnf {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  left: 16px;
  top: 8px;
  margin-left: -20px;
  .testpush {
    padding: 6px 12px;
    background: rgb(32, 98, 231);
    background-size: 20px;
    // padding-left: 35px;
    &:hover {
      background-color: #437ed9;
    }
    .icon {
      // width: 10px;
      // height: 10px;
      // background: url(../../../assets/images/Materials/tpush.png);
    }
  }
  .officialpush {
    padding: 6px 12px;
    background: rgb(32, 98, 231);
    //  url('../../../assets/images/Materials/opush.png') no-repeat 10px center;
    background-size: 20px;
    // padding-left: 35px;
    &:hover {
      background-color: #437ed9;
    }
  }
}
//修改快捷键浮框样式
//箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: white !important;
}
//箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: white !important;
}
//内容
.testtooltip {
  background: white !important;
  box-shadow: 1px 1px 10px 3px #d3d3d6;
}
.downClass {
  position: absolute;
  top: 70px;
  right: 20px;
}
.zoom {
  margin-top: -16px;
  position: absolute;
  top: -11px;
}
.quan {
  position: absolute;
  left: -87px;
  bottom: 4px;
}
.goReplate1 {
}
//升级-图标样式重定位
.positonIcon {
  position: absolute !important;
  top: -14px !important;
  left: 19px !important;
}
.positonIcon_a {
  top: -17px !important;
  left: 28px !important;
}
.positonIcon_b {
  top: -17px !important;
  left: 28px !important;
}
.positonIcon1 {
  position: absolute !important;
  top: -15px !important;
  left: 16px !important;
}
.positonIcon1_c {
  position: absolute !important;
  top: -15px !important;
  left: 26px !important;
}
.positonIcon2 {
  position: absolute !important;
  top: -17px !important;
  left: 9px !important;
}
.positonIcon2_a {
  top: -17px !important;
  left: 20px !important;
}
.positonLine {
  width: 1px;
  height: 20px;
  color: #999999;
  display: inline-block;
  background-color: #e6e6e6;
  // margin-left: -15px;
}
.positonIcon1-icon::before {
  background-image: url(../../assets/imagesZhi/Materials/hui.svg);
}
.positonIcon2-icon::before {
  background-image: url(../../assets/imagesZhi/Materials/撤销.svg);
}
.positonIcon2-icon-1::before {
  background-image: url(../../assets/imagesZhi/撤销置灰.svg);
}
.positonIcon1-icon-1::before {
  background-image: url(../../assets/imagesZhi/恢复置灰.svg);
}
.positonIcon3-icon::before {
  background-image: url(../../assets/imagesZhi/Materials/自动布局.svg);
}
.positonIcon4-icon::before {
  background-image: url(../../assets/imagesZhi/Materials/隐藏网格.svg);
}
.positonIcon5-icon::before {
  background-image: url(../../assets/imagesZhi/Materials/替换文案.svg);
}
.reduction::before {
  background-image: url(../../assets/imagesZhi/Materials/还原.svg);
}
.zoomOuts::before {
  background-image: url(../../assets/imagesZhi/Materials/放大.svg);
}
.zoomIns::before {
  background-image: url(../../assets/imagesZhi/Materials/缩小.svg);
}
.toggleFulls::before {
  background-image: url(../../assets/imagesZhi/Materials/全屏.svg);
}
.toggleFulls1::before {
  background-image: url(../../assets/imagesZhi/Materials/退出全屏.svg);
}
.popUp {
  position: fixed;
  z-index: 999999999999 !important;
  font-size: 12px;
}
//鼠标移入的样式----升级
.popUp1 {
  position: absolute;
  top: 16px;
  left: 1px;
  padding: 8px;
  background-color: #333;
  border-radius: 4px;
  z-index: 999999999999 !important;
  min-width: 140px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.arrow {
  position: absolute;
  width: 20px;
  min-height: 50px;
  border-radius: 12px;
  background: #ffffff;
  filter: drop-shadow(0 2px 12px 0 rgba(0, 0, 0, 0.1));
  padding: 10px;
  color: #606266;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 999999999999 !important;
}
.arrow::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom-color: #ffffff;
  top: -20px;
  left: 40px;
  z-index: 999999999999 !important;
}
.small-hit-area {
  /* 减小按钮的点击区域 */
  padding: 5px; /* 调整按钮内部的填充，减少点击范围 */
  /* 或者使用 background-clip: content; 让背景仅覆盖内容区域，从而减少点击范围 */
  background-clip: content-box;
}
.el-message-box__status {
  top: 20%;
  font-size: 20px !important;
}
.more-setting {
  display: flex;
  margin-right: 20px;
  align-items: center;
  cursor: pointer;
  &-right {
    margin-left: 5px;
  }
}
.config {
  &-text {
    margin-right: 10px;
  }
  &-select {
    width: 100px;
    margin-left: 4px;
  }
  &-num {
    margin-left: 110px;
  }
}
.require-icon {
  &::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  display: inline-block;
  color: #ccc;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
}

.tools {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  &-tip {
    color: #999999;
    margin-bottom: 4px;
    font-size: 12px;
  }
}

.name {
  height: 26px;
  &-text {
    height: 26px;
    line-height: 26px;
    display: inline-block;
    padding-left: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    font-size: 14px !important;
    color: #4f4f4f;
    font-weight: 600;
    &:hover {
      background: #eeeeee;
      border-radius: 2px;
    }
  }
  &-input {
    /deep/ .el-input__inner {
      height: 26px;
      line-height: 26px;
      &:focus {
        border-color: #3159ff;
      }
    }
  }
}
.aside_main_show {
  width: 0px !important;
  padding: 0;
  overflow: hidden;
}
/* 侧边栏按钮样式 */
.contractIcon {
  position: absolute;
  left: 0;
  top: 50%;
  width: 12px;
  height: 35px;
  line-height: 35px;
  color: #fff;
  background: rgba(102,102,102,0.4);
  border-radius: 0px 4px 4px 0px;
  font-size: 13px;
  z-index: 1000;
  cursor: pointer;
}
.contractIcon:hover {
  background: rgba(102,102,102,0.6);
  color: #fff;
}
</style>
